<template>
	<div class="chat-container">
		<!--サイドバー表示ボタン-->
		<button class="threebaricon" v-if="!showSideBar" @click="judgeSideBarPush">
			<img src="@/assets/ThreeBar.png" alt="ThreeBar.png" class="threebar-icon" />
		</button>
		<!--ChatBotタイトル-->
		<h2 class="title">営農支援AI(仮称)</h2>
		<!--サインアウトボタン-->
		<button class="signoutbtn" @click="onLogout">サインアウト</button>

		<!--入力された文字列と応答を画面に出力-->
		<main class="message-container" ref="messageContainer">
			<!--「SideBar.vue」からのトリガーで発動される関数を定義-->
			<!--サイドバーコンポーネントを表示する条件に基づいて表示・非表示を切り替える-->
			<!--サイドバーの「閉じる」ボタンが押されたときには、closeSidebarメソッドが呼び出されてサイドバーが非表示になる-->
			<SideBar
				@session-selected="handleSesstionSelect"
				@loading-finished="setLoadingFalse"
				v-if="showSideBar"
				@close-sidebar="closeSidebar"
				@show-confirm="showConfirmDialog"
				@session-backup="getSessionId"
				@initialize-false="initializeFalse"
				@index-backup="indexBackup"
				ref="sidebar"
				:isInitialize="isInitialize"
				:conversation_id="conversation_id"
				:activeindex_backup="activeindex_backup"
				:last_login_time="last_login_time"
				:loading="loading"
				:isLoading="isLoading"
			/>
			<!--チャット履歴削除画面の表示判定-->
			<ConfirmDialog v-if="isDialogVisible" @close="closeConfirmDialog" @delete-chat="deleteSession" />

			<!--Loading画面の表示判定(あくまで表示するだけ)-->
			<LoadingVue v-if="isLoading" />

			<!-- メッセージリストをループで表示 -->
			<div v-for="(message, index) in messages" :key="index">
				<!--userモードの時-->
				<!--ユーザーエリアにマウスを持っていくと、ゴミ箱ボタンを表示(ユーザーエリア以外にマウスを持っていくと、ゴミ箱ボタンを非表示にする)-->
				<div v-if="message.question" :class="['message', message.question.type]" @mouseenter="showButton(index)" @mouseleave="hideButton(index)">
					<div class="messageicon-container">
						<!--userアイコンを表示-->

						<!--AIからの回答が返ってきている場合-->
						<!--ユーザーからの回答が返ってきている場合-->
						<img :src="getIcon(message.question.type)" class="message-icon" :alt="message.question.type + ' icon'" />
						<!--ゴミ箱ボタンを配置(ユーザー側のみ)-->
						<button class="trashicon" v-show="showTrashButton[index]" @click="deleteSomeConversationData(index)">
							<img src="@/assets/TrashBox.png" alt="TrashBox.png" class="trash-icon" />
						</button>
					</div>

					<!--メッセージ表示部分-->
					<!--userモードの時-->
					<div class="message-text">{{ formatMessage(message.question.text) }}</div>
				</div>

				<!--botモードの時-->
				<!--ユーザーエリアにマウスを持っていくと、ゴミ箱ボタンを表示(ユーザーエリア以外にマウスを持っていくと、ゴミ箱ボタンを非表示にする)-->
				<div v-if="message.answer" :class="['message', message.answer.type]">
					<div class="messageicon-container">
						<!--botアイコンを表示-->
						<img :src="getIcon(message.answer.type)" class="message-icon" :alt="message.answer.type + ' icon'" />
					</div>

					<!--メッセージ表示部分-->

					<!--botのメッセージを表示-->
					<div v-if="loading && message == messages[messages.length - 1]" class="loader">
						<img src="@/assets/Loading.gif" alt="Loading..." />
					</div>
					<!--メッセージを表示-->
					<div v-else class="message-text">
						<div>{{ formatMessage(message.answer.text) }}</div>

						<!--画像URLと画像ファイルが返ってきている場合のみ読み込み-->
						<div v-if="message.imageUrl && message.imageFileNameList">
							<div v-for="(url, index) in message.imageUrl" :key="index">
								<br />
								<!--画像を出力-->
								<img :src="url" alt="rag_image_photo" class="image-size" />
								<!--画像ファイル名を出力(全角のファイル名があれば半角に直してから出力)-->
								{{ convertToHalfWidth(message.imageFileNameList[index]) }}
							</div>
						</div>

						<!--グラフ情報が返ってきている会話セットのみ、グラフを描画-->
						<div v-if="message.options">
							<br />

							<!--グラフ種別選択用ボタン-->
							<div class="dropdown">
								<button @click="toggleDropDown(index)">
									{{ currentChartTypeLabel(message.graphType) }}
								</button>
								<ul v-if="isDropDownOpen[index]">
									<li @click="updateChart(index, 'line', message.isTomatoSizeTwoSpan)">折れ線グラフ</li>
									<li @click="updateChart(index, 'bar', message.isTomatoSizeTwoSpan)">縦棒グラフ</li>
									<li @click="updateChart(index, 'pie', message.isTomatoSizeTwoSpan)">円グラフ</li>
								</ul>
							</div>

							<!--optionsにセットされているデータの数によって、グラフの数を追加-->
							<!-- ▼ 円グラフの複数対応ブロック：安全ガード＋keyを追加 ▼ -->
							<div v-if="message.graphType === 'pie' && message.isTomatoSizeTwoSpan" class="charts-grid">
								<div
									v-for="i in Math.min((message.options && message.options.length) || 0, (message.series && message.series.length) || 0)"
									:key="`pie-${index}-${i}-${JSON.stringify(message.dayName?.[i - 1] || '')}`"
									class="chart-card"
								>
									<!-- ラベル（存在チェック付き） -->
									<h4 class="chart-title">
										{{ message.dayName && message.dayName[i - 1] ? message.dayName[i - 1] : "" }}
									</h4>

									<!-- ApexCharts（円）: options/series の null/型ガード -->
									<apex-chart
										type="pie"
										v-if="message.options && message.series && Array.isArray(message.series[i - 1]) && message.series[i - 1].length > 0"
										:options="message.options[i - 1] || {}"
										:series="message.series[i - 1] || []"
										:key="`piechart-${index}-${i}`"
										height="320"
									/>
								</div>
							</div>

							<!-- 単体描画（従来）にもガードと key を追加して安全化 -->
							<div v-else class="chart-card">
								<apex-chart
									:type="message.graphType === 'pie' ? 'pie' : message.graphType === 'bar' ? 'bar' : 'line'"
									v-if="message.options && message.options[0] && message.series"
									:options="message.options[0]"
									:series="message.series[0]"
									:key="`single-${index}-${message.graphType}`"
									height="400"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</main>

		<!--メッセージ入力フォーム-->
		<div class="generalformposition">
			<div class="input-container">
				<textarea
					placeholder="AIにメッセージを送信する"
					v-model="newMessage"
					@keydown="handleKeydown"
					@input="resizeTextarea"
					@focus="handleFocus"
					@blur="handleBlur"
					id="textarea"
					required
				>
				</textarea>
				<!-- 音声入力ボタン -->
				<button class="micbtn" @click="toggleVoiceInput">
					<img :src="isVoiceInputActive ? require('@/assets/MicOn.svg') : require('@/assets/MicOff.svg')" alt="Mic" class="mic-icon" />
				</button>
				<!--メッセージ送信ボタン(飛行機アイコン仕様)-->
				<button class="sendbtn" @click="sendMessage">
					<img src="@/assets/PaperFly.png" alt="PaperFly.png" class="paperfly-icon" />
				</button>
			</div>
			<!-- 音声出力トグル -->
			<div class="toggle-container">
				<span>音声</span>
				<label class="toggle-switch">
					<input type="checkbox" v-model="isSpeechOutputActive" @input="toggleSpeechChange" />
					<span class="switch-slider"></span>
				</label>
			</div>
		</div>
	</div>
</template>

<script>
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import SideBar from "@/components/SideBar.vue";
import VueApexCharts from "vue3-apexcharts";
import { ref, onMounted, nextTick, computed, unref } from "vue";
import { msalInstance, ensureSignedIn } from "@/msalConfig";
import LoadingVue from "@/components/LoadingVue.vue";
import { logout } from "@/utils/logout";
import { useAuthStore } from "@/stores/authStore";
import { authFetch } from "@/utils/authFetch";

export default {
	components: {
		SideBar,
		ConfirmDialog,
		LoadingVue,
		apexChart: VueApexCharts,
	},
	setup() {
		const authStore = useAuthStore();

		// ローカル状態
		const isLoading = ref(true);
		const sidebar = ref("");
		const last_login_time = ref("");
		const function_ip = process.env.VUE_APP_API_URL;
		const signingOut = ref(false);
		const houseId = ref("");

		// サインアウト処理
		const onLogout = async () => {
			console.log("[AIChat] onLogout clicked. signingOut =", signingOut.value);
			// 最終ログイン時間の保存は失敗しても後続へ進む
			try {
				await getLastLoginTime();
			} catch (e) {
				console.warn("[AIChat] getLastLoginTime failed:", e);
				// 続行（ログアウトは優先）
			}
			// 二重押し防止
			if (signingOut.value) {
				console.log("[AIChat] blocked by signingOut guard");
				return;
			}
			signingOut.value = true;
			try {
				console.log("[AIChat] calling logout()");
				await logout();
			} catch (e) {
				console.warn("logout failed:", e);
			} finally {
				signingOut.value = false;
				console.log("[AIChat] logout flow done.");
			}
		};

		// 前回のログイン時間を取得
		async function getLastLoginTime() {
			const url = `${function_ip}&action=GetLastLoginTime`;
			try {
				const response = await authFetch(url, {
					method: "GET",
					headers: {
						"Content-Type": "application/json",
					},
				});

				if (!response.ok) {
					throw new Error("Network response was not ok");
				}

				const data = await response.json();
				// ここでdataの処理を行う
				return data.last_login_time; // ここでデータを返す
			} catch (error) {
				console.error("Error fetching last login time:", error);
				throw error; // エラーを呼び出し元に投げる
			}
		}

		// アカウント情報を取得（圃場ID）
		const getAccountInfo = async () => {
			const url = `${function_ip}&action=GetAccountInfo`;
			try {
				const response = await authFetch(url, {
					method: "GET",
					headers: {
						"Content-Type": "application/json",
					},
				});

				if (!response.ok) {
					throw new Error("Network response was not ok");
				}

				const data = await response.json();
				// ここでdataの処理を行う
				return data.house_id; // ここでデータを返す
			} catch (error) {
				console.error("Error fetching account info:", error);
				throw error; // エラーを呼び出し元に投げる
			}
		};

		async function handleAuthentication() {
			try {
				// 初期化＆サインイン保証（内部で initialize と handleRedirect を実行）
				await ensureSignedIn();

				// 現在のアカウント情報を反映
				const account = msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0] ?? null;
				if (!account) {
					// ここに来るのは稀（リダイレクト直後など）。念のためリトライ。
					await ensureSignedIn();
					return;
				}
				authStore.isAuthenticated = true;
				authStore.userName = account.name ?? "";
				authStore.userId = account.homeAccountId;

				// 前回のログイン時間を取得
				last_login_time.value = await getLastLoginTime();
				if (last_login_time.value == null) {
					last_login_time.value = "なし";
				}
				// 圃場IDの取得→サイドバーの会話履歴を更新
				authStore.houseId = await getAccountInfo();
				houseId.value = computed(() => authStore.houseId);
				await nextTick();
				sidebar.value?.fetchConversations?.();
			} catch (e) {
				console.error("handleAuthentication error:", e);
				authStore.isAuthenticated = false;
			}
		}

		onMounted(async () => {
			// 初回、ログイン処理を実行
			await handleAuthentication();
		});

		return {
			onLogout,
			sidebar,
			last_login_time,
			isLoading,
			houseId,
			function_ip,
		};
	},
	data() {
		return {
			// 糖度データのグラフ切替フラグ
			isBrixYearOverlay: false,
			// メッセージ入力フォームで入力された文字列
			newMessage: "",
			// tsuzumiからのレスポンス格納用文字列
			response: "",
			// メッセージのリスト
			messages: [],
			// メッセージ入力フォーム要素格納用変数
			getTextarea: null,
			// サイドバー表示用フラグ(falseの場合、サイドバーを非表示)
			showSideBar: true,
			// ゴミ箱ボタン表示判定フラグ(message.typeがuser側のみ表示するようにする)
			showTrashButton: {},
			// ぐるぐるGIF表示フラグ(初回はfalseで非表示設定)
			loading: false,
			// 会話セッションIDの格納用変数
			conversation_id: null,
			// チャット履歴確認画面表示判定フラグ
			isDialogVisible: false,
			// 初回データ読み込み判定フラグ
			isInitialize: true,
			// サイドバーボタンで選択中のインデックス(バックアップ用)
			activeindex_backup: 0,
			// バックエンドから受け取ったURL格納用リスト
			imageUrl: [],
			// バックエンドから受け取った画像URLから抽出した画像ファイル名格納用リスト
			imageFileNameList: [],
			// ApexChartsの設定
			chart: {
				// 各データからグラフ生成時に毎度追加される配列(複数グラフ描画のために必要)
				graphArrayData: [],
			},
			// ApexChartsに描画する各座標
			x_value: "",
			y_value: "",
			// グラフ生成時に使用するパラメーター(初回は-1で初期化)
			graphIndex: -1,
			// グラフデータ、存在チェック
			isGraphData: false,
			// 各メッセージのドロップダウン状態を初期化
			isDropDownOpen: [false, false, false],
			// サイドバーボタン押下時に読み取るメッセージ格納用リスト
			// (ローカル変数からグローバル変数に変更)
			chatMessages: [],
			// 今作のスタート期間
			period_of_seedlings_made_start: "2024/8/22",
			// 今作のファイナル期間
			period_of_seedlings_made_final: "2025/1/15",
			// 複数円グラフ描画時から縦棒グラフに切り替え時のラベル描画順
			classBarOrder: ["3L以上", "2L", "L", "M", "S", "2S", "小玉", "C", "出荷基準外", "廃棄"],
			// 複数円グラフ描画時のラベル描画順
			classPieOrder: ["3L以上", "2L", "L", "M", "S", "2S", "小玉", "C", "出荷基準外", "廃棄", "総収量"],
			// 複数円グラフ描画時に使用するグラフの指定色
			colorPalette: {
				"3L以上": "#26A69A", // 3L以上 (ディールグリーン)
				"2L": "#775DD0", // 2L (紫)
				L: "#FFB2D3", // L (薄いピンク)
				M: "#FF4560", // M (赤)
				S: "#A3A0FB", // S (ラベンダー)
				"2S": "#FF9F00", // 2S (オレンジ)
				小玉: "#00E396", // 小玉 (緑)
				C: "#00c6c0", // C (ティール)
				出荷基準外: "#008FFB", // 出荷基準外 (青)
				廃棄: "#546E7A", // 廃棄 (ダークグレー)
				総収量: "#D3D3D3", // 総収量 (グレー)
			},
			recognition: null, // SpeechRecognitionインスタンス
			isTextareaFocused: false, // テキストエリアがフォーカスされているかどうか
			isVoiceInputActive: false, // 音声入力の状態管理
			isSpeechOutputActive: false, // 音声出力の状態管理
			voices: [], // 音声リスト
			japaneseVoices: [], // 日本語の音声リスト
			selectedVoice: null, // ユーザーが選択した音声
			attempts: 0, // リトライ回数
			maxAttempts: 5, // 最大リトライ回数
			osSystem: null,
			voice_microsoft: "Microsoft Haruka - Japanese (Japan)", // 以下から音声を指定する
			/*
					0:	Microsoft Ayumi - Japanese (Japan)
					1:	Microsoft Haruka - Japanese (Japan)
					2:	Microsoft Ichiro - Japanese (Japan)
					3:	Microsoft Sayaka - Japanese (Japan)
					以下はEdgeのみ利用可能（Chromeでは利用できない）
					4:	Microsoft Keita Online (Natural) - Japanese (Japan)
					5:	Microsoft Nanami Online (Natural)
			*/
			voice_apple: "Kyoko", // apple製品は以下から音声を選択（iPadがKyokoしか選択できない）
			/*
					0: Eddy
					1: Reed
					2: Shelley
					3: Kyoko
					4: Grandma
					5: Rocko
					6: Grandpa
					7: Sandy
					8: Flo
					9: Kyoko
			*/
		};
	},

	mounted() {
		// userAgentを取得
		this.osSystem = this.getOperatingSystem();
		// console.log(this.osSystem);
		// textareaの要素を取得(初回のみ)
		this.getTextarea = document.getElementById("textarea");
		// 音声が追加された場合に再度リストを取得するためのイベントリスナーを追加
		this.loadVoices();
		window.speechSynthesis.onvoiceschanged = () => {
			this.loadVoices();
		};
	},

	methods: {
		// 音声入力のトグルを制御するメソッド
		toggleVoiceInput() {
			// 音声入力の状態を反転させる（ON / OFF）
			this.isVoiceInputActive = !this.isVoiceInputActive;

			if (this.isVoiceInputActive) {
				// 音声入力がONになった場合、音声認識を開始する
				console.log("音声入力ON");
				this.startRecognition();
			} else {
				// 音声入力がOFFになった場合、音声認識を停止する
				this.stopRecognition();
				console.log("音声入力OFF");
			}
		},

		// 音声認識を開始するメソッド
		startRecognition() {
			// Web Speech APIのSpeechRecognitionをサポートしているか確認
			if (window.SpeechRecognition || window.webkitSpeechRecognition) {
				// どちらかのSpeechRecognitionを選択し、新しいインスタンスを作成
				this.recognition = new (window.SpeechRecognition || window.webkitSpeechRecognition)();
				this.recognition.lang = "ja-JP"; // 認識言語を日本語に設定
				this.recognition.interimResults = false;
				this.recognition.maxAlternatives = 1;

				// 音声を認識した結果が得られた時のイベントハンドラー
				this.recognition.onresult = (event) => {
					const transcript = event.results[0][0].transcript; // 認識結果を取得
					this.newMessage += transcript; // 認識されたテキストを入力フォームに追加
					// console.log("認識結果:", transcript); // コンソールに認識されたテキストを表示
				};

				// エラーハンドリング
				this.recognition.onerror = (event) => {
					console.error("Speech recognition error:", event.error);
					console.log("音声入力OFF（エラー）");
				};

				// 音声認識が終了した時の処理
				this.recognition.onend = () => {
					this.isVoiceInputActive = false; // 音声入力をOFFの状態に戻す
				};

				// 音声認識を開始
				this.recognition.start();
			} else {
				// Web Speech APIが利用できない場合の警告メッセージ
				alert("お使いのブラウザはWeb Speech APIをサポートしていません。");
			}
		},

		// 音声認識を停止するメソッド
		stopRecognition() {
			if (this.recognition) {
				this.recognition.stop(); // 音声認識を停止
			}
		},

		// 使用可能な音声リストを取得するメソッド
		loadVoices() {
			// 音声リストを取得
			this.voices = speechSynthesis.getVoices();
			// console.log("音声一覧：", voices);
			if (this.voices.length > 0) {
				// 日本語の音声をフィルタリング
				this.japaneseVoices = this.voices.filter((voice) => voice.lang.startsWith("ja"));
				// this.japaneseVoices.forEach((voice, index) => {
				// 	console.log(`${index}: ${voice.name}`);
				// });
				// console.log("選択可能な日本語音声：", this.japaneseVoices);

				// 音声を指定
				if (this.japaneseVoices.length > 0) {
					if (this.osSystem === "Windows") {
						const targetVoice = this.japaneseVoices.find((voice) => voice.name === this.voice_microsoft && voice.lang === "ja-JP");
						this.selectedVoice = targetVoice || this.japaneseVoices[0]; // 指定した音声が見つからなければ最初の音声
					} else if (this.osSystem === "Mac" || this.osSystem === "iPhone" || this.osSystem === "iPad") {
						const targetVoice = this.japaneseVoices.find((voice) => voice.name === this.voice_apple && voice.lang === "ja-JP");
						this.selectedVoice = targetVoice || this.japaneseVoices[0]; // 指定した音声が見つからなければ最初の音声
					} else {
						this.selectedVoice = this.japaneseVoices[0]; // その他のOSの場合は最初の音声
					}
					// console.log("選択された音声:", this.selectedVoice.name);
				}
			} else {
				// リトライロジック
				if (this.attempts < this.maxAttempts) {
					this.attempts++;
					setTimeout(this.loadVoices, 1000); // 1秒後に再試行
				} else {
					console.error("音声リストが取得できませんでした。");
				}
			}
		},

		// 実行されているOSを取得
		getOperatingSystem() {
			const userAgent = navigator.userAgent;
			// console.log(userAgent);
			if (userAgent.indexOf("Windows") !== -1) {
				return "Windows";
			} else if (userAgent.indexOf("Macintosh") !== -1) {
				return "Mac";
			} else if (userAgent.indexOf("iPhone") !== -1) {
				return "iPhone";
			} else if (userAgent.indexOf("iPad") !== -1) {
				return "iPad";
			} else if (userAgent.indexOf("Android") !== -1) {
				return "Android";
			} else if (userAgent.indexOf("Linux") !== -1) {
				return "Linux";
			} else {
				return "Unknown OS";
			}
		},

		// 音声出力トグルをオフにするとき、読み上げを停止
		toggleSpeechChange(event) {
			this.isSpeechOutputActive = event.target.checked;
			console.log("音声読み上げが" + (this.isSpeechOutputActive ? "有効" : "無効") + "になりました");
			// ウォームアップ処理
			this.setupSpeech();
			console.log("選択可能な日本語音声：", this.japaneseVoices);
			console.log("選択された音声:", this.selectedVoice.name);
		},

		// ウォームアップ処理
		setupSpeech() {
			if (!window.speechSynthesis._warmedUp) {
				const dummy = new SpeechSynthesisUtterance("...");
				dummy.volume = 0; // 無音
				dummy.onend = () => {
					window.speechSynthesis._warmedUp = true; // ウォームアップ完了
					console.log("音声合成ウォームアップ完了");
				};
				window.speechSynthesis.speak(dummy); // ウォームアップ用の音声を発話
			}
		},

		// テキストエリアがフォーカスされた時
		handleFocus() {
			this.isTextareaFocused = true; // フォーカス時に状態を更新
		},

		// テキストエリアのフォーカスが外れた時
		handleBlur() {
			this.isTextareaFocused = false; // フォーカスが外れたら更新
		},

		// ローディングを非表示にするメソッド
		setLoadingFalse() {
			const intervalId = setInterval(() => {
				// houseIdが空でないか確認
				if (this.houseId !== "") {
					// ここでhouseIdが設定された後の処理を行う
					clearInterval(intervalId); // ループを停止
					this.isLoading = false; // ローディングを非表示にする
				} else {
					// console.info("houseId is still empty.");
				}
			}, 1000); // 1秒ごとに確認
		},

		// サイドバーボタン押下判定
		// サイドバーが閉じているとき、リクエスト中(ぐるぐる表示中)はサイドバーボタンを押下してもサイドバーが表示されないようにする
		judgeSideBarPush() {
			// ローディング中はサイドバーボタン押下不可能
			if (this.loading) {
				// console.log("リクエスト中のため、サイドバーをだせません");
				return;
			}
			// そうでない場合にはサイドバーボタン押下でサイドバーを出現
			else {
				this.showSideBar = true;
				// console.log("リクエストが返ってきているため、サイドバーを表示");
			}
		},
		// グラフ種別選択ボタンのラベル表記の制御
		currentChartTypeLabel(graphType) {
			return graphType == "line" ? "折れ線グラフ" : graphType == "bar" ? "縦棒グラフ" : "円グラフ";
		},
		// グラフ種別選択ボタン押下時のトグル制御
		toggleDropDown(index) {
			// ローディング中ではない場合のみ、グラフ種別押下可能とする
			if (!this.loading) {
				this.isDropDownOpen[index] = !this.isDropDownOpen[index];
			}
		},
		// グラフ種別選択時のボタン表示制御
		async updateChart(index, type, isTomatoSizeTwoSpan) {
			// console.log("グラフ種別ボタン押下時のサイズごとのトマトグラフのフラグ", isTomatoSizeTwoSpan);
			// console.log("グラフ種別ボタン押下時のグラフ種別", type);

			// グラフ種別選択ボタン押下時のグラフが複数の円グラフからではない場合、今まで通り、そのままgraphTypeを差し替え
			if (!isTomatoSizeTwoSpan) {
				// messagesのgraphTypeを更新
				this.messages[index].graphType = type;
			} else if (isTomatoSizeTwoSpan) {
				// 複数シリーズから折れ線グラフに切り替えたい場合は、そのままgraphTypeを差し替え
				if (type == "line") {
					// messagesのgraphTypeを更新
					this.messages[index].graphType = type;
					// console.log("複数シリーズから折れ線グラフへ切り替えます");
				}
				// 複数の円グラフ表示から縦棒グラフへ切り替えた場合、仮のgraphDataを代入してサイズごとの縦棒グラフを再描画
				else if (type == "bar") {
					// messagesのgraphTypeの中身を仮のgraphTypeを代入
					this.messages[index].graphType = "pietobar";
					// console.log("type変更後のchatMessagesの中身", this.chatMessages);
					// console.log("複数の円グラフ表示から縦棒グラフへ切り替えます");
				}
				// サイズごとの縦棒グラフから複数の円グラフへ切り替えた場合、グラフタイプを変更して複数の円グラフを再描画
				else {
					this.messages[index].graphType = "pietwospan";
					// console.log("サイズごとの縦棒グラフから複数の円グラフへ切り替えます");
				}
			}
			// console.log("格納済のchatMessages", this.chatMessages[index - 1]);
			// console.log(type);
			// console.log("再描画する時のmessages", this.messages);

			// ★ bar → line に切り替える時に、対象が Brix データなら「年別×MM/DD オーバーレイ」フラグを ON
			//   - messages[index]（または chatMessages）の graphData 内に brix が存在すれば Brix と判定
			try {
				const msg = this.messages[index] ?? {};
				const gd = Array.isArray(msg.graphData) ? msg.graphData : [];
				const isBrix = gd.some((it) => it && it.brix !== undefined && it.date !== undefined);
				// 初期 bar からの line への切替だけを対象にしたい場合、直前が bar だったかも確認可能
				if (type === "line" && isBrix) {
					this.isBrixYearOverlay = true;
				} else {
					this.isBrixYearOverlay = false;
				}
			} catch (e) {
				// 判定で例外が出ても既存挙動を壊さない
				this.isBrixYearOverlay = false;
			}

			// ★常にUIの最新（messages）をスナップショットしてから再描画
			//   SideBarの開閉に関係なく、最新のQ&Aを含めて再構築する
			this.chatMessages = JSON.parse(JSON.stringify(this.messages));
			this.repaintGraph();

			// ★ 一度使ったらフラグを戻す（次回他データの line で誤判定しないように）
			this.isBrixYearOverlay = false;

			// ドロップダウンを閉じる
			this.isDropDownOpen[index] = false;
		},
		// ユーザー側で入力されたメッセージを画面に出力後、クエリを送信
		async sendMessage() {
			// console.log("音声読み上げ開始:", this.isSpeechOutputActive);
			// 何も入力されていない場合は、メッセージを送信しない
			if (this.newMessage.trim() === "" || this.loading) {
				// console.log("入力文字列が空 or ローディング中のためメッセージの送信不可能");
				return;
			}

			// メッセージを処理するロジック
			// ユーザーのメッセージをリストに追加
			this.messages.push({
				question: { text: this.newMessage, type: "user" },
				answer: null,
				imageUrl: null,
				imageFileNameList: null,
			});
			// 最下部まで自動スクロール
			await this.scrollToBottom({ smooth: true });
			// ユーザーが入力したメッセージをバックアップ
			const userMessage = this.newMessage;

			// データの変更が反映された後に、コールバックを実施
			this.$nextTick(() => {
				// 入力したメッセージをAzure AI Search、LLMへ投げる
				this.replyToMessage(userMessage);
			});
			// 入力内容をクリア
			this.newMessage = "";
			// キーボード入力内容とサイズをリセット
			this.resetTextArea();
		},
		// 全角文字を半角文字に変換
		convertToHalfWidth(input) {
			// console.log("全角文字があれば、半角文字に直します");

			return input
				.replace(/[０-９]/g, (match) => String.fromCharCode(match.charCodeAt(0) - 0xfee0))
				.replace(/[Ａ-Ｚ]/g, (match) => String.fromCharCode(match.charCodeAt(0) - 0xfee0))
				.replace(/[ａ-ｚ]/g, (match) => String.fromCharCode(match.charCodeAt(0) - 0xfee0))
				.replace(/（/g, "(")
				.replace(/）/g, ")")
				.replace(/／/g, "/")
				.replace(/％/g, "%")
				.replace(/＃/g, "#");
		},

		// ユーザー側で入力されたメッセージを受け取り、回答を返す
		async replyToMessage(userMessage) {
			// Azure Funcstionsの接続先を指定
			const api_url = this.function_ip + "&action=PostPromptToAzure";

			// ローディングを開始
			this.loading = true;

			// 一時的に空文字をリストの末尾に追加(ぐるぐる表示をしたいため)
			setTimeout(() => {
				this.messages.push({
					question: null,
					answer: { text: "", type: "bot" },
					imageUrl: null,
					imageFileNameList: null,
				});

				// データの変更が反映された後に、コールバックを実施
				this.$nextTick(() => {
					// 最下部まで自動スクロール
					this.scrollMessageContainer();
				});
			}, 0);

			// 「ユーザーID」と「ユーザーが投げた質問」、「会話セッションID」をjsonにしてPythonに投げる

			// PythonのAPIを呼び出し、プロンプトを投げる

			// ユーザーメッセージ中に、全角文字があれば半角文字に変換
			const convetedUserMessage = this.convertToHalfWidth(userMessage);
			// console.log("全角→半角変換後の文字列", convetedUserMessage);

			// 選択中の会話セッションIDと、ユーザーメッセージをオブジェクトとして定義
			const dataToSend = {
				// 選択中の会話セッションIDをセット
				chat_session_id: unref(this.conversation_id),
				// ユーザーが投げた質問をセット
				question_text: String(convetedUserMessage),
				house_id: unref(this.houseId),
			};

			try {
				// バックエンドにリクエストを送る
				const response = await authFetch(api_url, {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify(dataToSend),
				});
				// APIからのレスポンスをjson形式で取得する
				const answer = await response.json();

				// APIから返ってきたjsonデータのうち、resultのみを画面に出力させるための変数に代入
				this.response = answer.result;
				// 画像URLリストを取得(SASトークン付き)
				this.imageUrl = answer.insite_urls;

				//それぞれの情報をログに出力
				console.log("天気APIからの情報", answer.weather);
				console.log("DBからの情報", answer.db);
				console.log("RAGからの情報", answer.rag);
				console.log("RAGからの画像URL", answer.urls);
				console.log("tsuzumiからの回答", answer.result);
				// console.log("グラフ種別判断", answer.judge_graphtype);

				// バックエンドから画像URLが返ってきた場合、そのURLから画像ファイル名を抽出する
				if (answer.urls.length != 0) {
					// 画像URLから画像ファイル名を抽出してリスト化
					this.imageFileNameList = this.getImageFileName(answer.urls);

					// console.log("画像URLから画像ファイル名を抽出しました");
					// console.log("抽出した画像ファイル名リスト", this.imageFileNameList);
				}
				// 画像URLが返ってきていない場合は、画像ファイル名を格納するリストを空にする
				else {
					// リストの中身を初期化
					this.imageFileNameList = [];
					// console.log("画像ファイルが返ってきていないため、リストを初期化します");
				}

				// 逆質問パターンではない、かつDBデータが返ってきた場合のみ、DBからの情報を受け取る
				// ※CosmosDBから返ってくるデータの配列の長さが1つの場合にはグラフを表示させない(2つ以上でグラフを表示)
				if (answer.db != answer.result && answer.db != "" && answer.db.length > 1) {
					// console.log("グラフを出力");
					// グラフをセット
					this.setGraph(answer.judge_graphtype);

					// グラフ表示用の変数に値をセット(あくまでグラフ描画の準備だけ)
					this.prepareChartData(answer.db, answer.judge_graphtype, userMessage);
					// グラフデータ確認フラグをオン
					this.isGraphData = true;
				} else {
					// console.log("グラフを出力しない");
					// グラフデータ確認フラグをオフ
					this.isGraphData = false;
				}
				// ローディング表示を終了、メッセージを画面に出力
				this.addResult(answer.judge_graphtype, answer.db);

				// サイドバーが表示されていた場合は、そのまま最新のデータを読み込む
				if (this.showSideBar) {
					// SideBar.vueのfetchConversationsメソッドをサイレントで呼び出す
					this.$refs.sidebar.fetchConversations(true);
				}
			} catch (error) {
				//通信エラー時
				console.error(error);

				const errorMessage = "通信エラーが発生しました。接続先を確認してください。";
				// エラーメッセージを代入
				this.response = errorMessage;

				// グラフデータ確認フラグをオフ
				this.isGraphData = false;

				// ローディング表示を終了、エラーメッセージを画面に出力
				this.addResult("", "");
			}
		},
		// 画像URLから画像ファイル名のみを抽出する
		getImageFileName(imageUrl) {
			let imageFileName = imageUrl.map((url) => {
				// URLをクエスチョンマークで分割し、最初の部分を取得
				// ※ データ問い合わせ時に、SASトークン部分を排除する処理
				let cleanUrl = url.split("?")[0];
				// console.log("?以降を除外したもののURL", cleanUrl);

				// URLをスラッシュで分割し、最後の要素を取得
				return cleanUrl.split("/").pop();
			});
			// console.log("ここで画像URLから画像ファイルを抽出します");

			return imageFileName;
		},
		// 結果を画面に表示させるためのリストの変数に追加
		async addResult(graphType, dbData) {
			// ローディングを終了
			this.loading = false;

			// リストの末尾に追加した空文字を削除後、再度リストの末尾にサーバーからの応答を追加
			// ※この処理を毎度メッセージが入力されサーバーからの応答が返ってくるたびに実施する
			this.messages.pop();
			// console.log(this.messages);

			// 複数グラフの描画用の代入判定フラグ
			var isTwoGraphData = false;

			// バックエンドから返ってきたグラフ種別が「pietwospan」の場合
			// パラメーターを「pie」に直してからメッセージ配列に代入する
			if (graphType == "pietwospan") {
				graphType = "pie";

				// 代入判定フラグをtrueに設定
				isTwoGraphData = true;

				// console.log("文字列を「pie」に設定します");
			}

			// LLMから返ってきた応答 or エラーメッセージを末尾に追加
			setTimeout(() => {
				// 複数データが返ってきていない場合には、そのまま単体のデータを代入
				if (this.isGraphData && !isTwoGraphData) {
					this.messages.push({
						question: null,
						answer: { text: this.response, type: "bot" },
						imageUrl: this.imageUrl,
						imageFileNameList: this.imageFileNameList,
						// バックエンドから返ってきたグラフの種別をセット
						graphType: graphType,
						// バックエンドから返ってきたDBのデータをセット(グラフ種別切り替え時の再描画用)
						graphData: dbData,
						// グラフ描画の際のX軸の値をセット(値が返ってきていない場合はnullでセット)
						options: [this.chart.graphArrayData[this.graphIndex].options],
						// グラフ描画の際のY軸の値をセット(値が返ってきていない場合はnullでセット)
						series: [this.chart.graphArrayData[this.graphIndex].series],
						// 複数グラフ描画フラグをオフ
						// ※ 複数グラフ描画時のみフラグをオン
						isTomatoSizeTwoSpan: false,
					});
					// console.log("グラフデータあり");
					// console.log("単体のグラフ描画用のメッセージリストを追加");
					// console.log("push後のmessages(単体)", this.messages);
				}
				// 複数データが返ってきている場合には、複数のデータを代入
				else if (this.isGraphData && isTwoGraphData) {
					// console.log("複数グラフ描画用のメッセージリストを追加");
					const { start, end } = this.lastPieChartRange;
					const idxList = Array.from({ length: end - start + 1 }, (_, k) => start + k);

					this.messages.push({
						question: null,
						answer: { text: this.response, type: "bot" },
						imageUrl: this.imageUrl,
						imageFileNameList: this.imageFileNameList,
						// バックエンドから返ってきたグラフの種別をセット
						graphType: "pie",
						// バックエンドから返ってきたDBのデータをセット(グラフ種別切り替え時の再描画用)
						graphData: dbData,
						// 複数の円グラフが描画される時に表示する「年-月」表示をセット
						dayName: idxList.map((i) => this.chart.graphArrayData[i].dayName),
						// グラフ描画の際のX軸の値を2グラフ分セット(値が返ってきていない場合はnullでセット)
						options: idxList.map((i) => this.chart.graphArrayData[i].options),
						// グラフ描画の際のY軸の値を2グラフ分セット(値が返ってきていない場合はnullでセット)
						series: idxList.map((i) => this.chart.graphArrayData[i].series),
						// 複数グラフ描画フラグをオン
						isTomatoSizeTwoSpan: true,
					});
					// console.log("push後のmessages(複数)", this.messages);
				} else {
					this.messages.push({
						question: null,
						answer: { text: this.response, type: "bot" },
						imageUrl: this.imageUrl,
						imageFileNameList: this.imageFileNameList,
						// グラフの種別をnullでセット
						graphType: null,
						// X軸の値をnullでセット
						options: null,
						// Y軸の値をnullでセット
						series: null,
					});
					// console.log("グラフデータなし");
				}
				// console.log("サイドバーを閉じてリクエスト時のthis.messages", this.messages);
				if (this.isSpeechOutputActive) {
					this.readMessage(); // メッセージを読み上げる
				}
				// 取得したtsuzumiからの回答をクリア
				this.response = "";
				// 取得した画像URL(ローカル)をクリア
				this.imageUrl = [];
				// 取得した画像ファイル名リスト(ローカル)をクリア
				this.imageFileNameList = [];

				// データの変更が反映された後に、コールバックを実施
				this.$nextTick(() => {
					// 最下部まで自動スクロール（グラフ描画直後は強制）
					this.scrollToBottom({ smooth: false, retries: 8, force: true });
				});
			}, 0);
		},

		// 読み上げ処理
		readMessage() {
			const utterance = new SpeechSynthesisUtterance(this.response);
			utterance.lang = "ja-JP"; // 音声の言語を日本語に設定
			utterance.voice = this.selectedVoice; // 選択した音声を設定
			speechSynthesis.speak(utterance);
		},

		// アイコンのパスより、アイコン画像を返す
		getIcon(type) {
			if (type === "user") {
				// ユーザーアイコンのパス
				return require("@/assets/People.png");
			} else if (type === "bot") {
				// ボットアイコンのパス
				return require("@/assets/Robot.png");
			}
		},
		// 返されたテキストの文字列の型チェック
		formatMessage(text) {
			// tsuzumiから返ってきた応答が文字列でない場合は文字列に変換

			let processedText;

			// 文字列がどうか、確認
			if (typeof text === "string") {
				// 文字列の場合はそのまま
				processedText = text;
				// console.log("文字列が返ってきているため、そのまま渡します");
			} else {
				// それ以外の場合はJSON文字列に変換
				processedText = JSON.stringify(text);
				// console.log("文字列ではないため、JSON文字列に変換します");
				// console.log("JSON変換後の文字列", processedText);
			}

			return processedText;
		},
		// 押下されたキーによって、イベントを制御
		handleKeydown(event) {
			if (event.key === "Enter" && !event.shiftKey) {
				// デフォルトのEnterキー動作を防止（改行の防止）
				event.preventDefault();
				// メッセージを送信
				this.sendMessage();
			}
		},

		// メッセージ入力フォームで改行される際のCSS高さを自動調整
		resizeTextarea() {
			// 高さをリセットしてから、内容に基づいて高さを再計算
			this.getTextarea.style.height = "auto";
			const newHeight = this.getTextarea.scrollHeight; // 新しい高さを計算
			this.getTextarea.style.height = newHeight + "px"; // 高さを設定
			// console.log(this.getTextarea.style.height);
		},
		// メッセージ入力フォームのサイズリセット
		resetTextArea() {
			// 元のサイズにリセット
			if (this.getTextarea.style.height != "43px") {
				this.getTextarea.style.height = "43px";
			}
			// メッセージ内容クリア
			this.newMessage = "";
		},
		// メッセージ出力後の自動スクロール処理
		async scrollMessageContainer() {
			// // 現在の高さを取得して、スクロール位置を最下部に持っていく
			await this.scrollToBottom({ smooth: true });
		},

		// ユーティリティ：最下部へスクロール（高さ確定待ち＋リトライ付き）
		async scrollToBottom({ smooth = false, retries = 6, force = false } = {}) {
			const container = this.$refs.messageContainer;
			if (!container) return;

			// ユーザーが最下部付近にいるかどうか（100px 以内なら追随）
			const nearBottom = Math.abs(container.scrollHeight - container.scrollTop - container.clientHeight) < 100;

			//強制モードならガード無効。通常は「最下部付近でのみ」スクロール
			if (!force) {
				if (!nearBottom && !this.loading) return;
			}

			// 1) DOM 更新待ち
			await this.$nextTick();

			// 2) rAF でレイアウト確定後に実行
			await new Promise((resolve) => requestAnimationFrame(resolve));

			const doScroll = () => {
				const target = container.scrollHeight - container.clientHeight;
				if (smooth) {
					container.scrollTo({ top: target, behavior: "smooth" });
				} else {
					container.scrollTop = target;
				}
			};

			doScroll();

			// 3) 後追いで高さが増えるケースに短いリトライ
			for (let i = 0; i < retries; i++) {
				await new Promise((r) => setTimeout(r, 120)); // ApexCharts/画像ロード待ち
				const atBottom = Math.abs(container.scrollHeight - container.scrollTop - container.clientHeight) < 2;
				if (atBottom) break;
				doScroll();
			}
		},

		// サイドバー非表示フラグ制御
		closeSidebar() {
			// サイドバーを閉じる
			this.showSideBar = false;
		},
		// ゴミ箱ボタン表示判定フラグ(マウスオーバー時)
		showButton(zoneId) {
			// ローディング中はごみ箱ボタン押下不可能
			if (this.loading) {
				// console.log("ローディング中のため、ごみ箱ボタンは出現しません");
				return;
			} else {
				// ボタン表示判定フラグをオンにして、ゴミ箱ボタンを表示(message.typeがtrueの場合のみ)
				this.showTrashButton[zoneId] = true;
			}
		},
		// ゴミ箱ボタン表示判定フラグ(マウスオーバーしていない時)
		hideButton(zoneId) {
			// ボタン表示判定フラグをオフにして、ゴミ箱ボタンを非表示
			this.showTrashButton[zoneId] = false;
		},
		// フィルタリングされたメッセージをリストに格納、会話セッションIDの取得
		async handleSesstionSelect(returnMessages, sesstionid) {
			// SideBar.vueから届いた配列をプレーンJSONに（リアクティブ参照を断つ）
			this.chatMessages = JSON.parse(JSON.stringify(returnMessages));

			// console.log("更新後のchatMessages", this.chatMessages);

			// クリックされたサイドバーボタンの会話セッションIDを取得
			this.conversation_id = sesstionid;
			// console.log("選択された会話セッションID", this.conversation_id);

			// 一度、初回のデータを全て削除
			this.messages.splice(0);
			await this.$nextTick();
			// グラフデータ格納用のリストとそのリストインデックスをリセット
			this.resetGraphArray();

			// 初回のデータをmessagesに代入
			this.messages.push({
				question: null,
				answer: { text: "質問したい事項を入力してください。", type: "bot" },
				imageUrl: null,
				imageFileNameList: null,
				// バックエンドから返ってきたグラフの種別をnullでセット
				graphType: null,
				// X軸の値をnullでセット
				options: null,
				// Y軸の値をnullでセット
				series: null,
				apexReady: false,
			});
			// console.log("1番目に追加された初回データ", this.messages);
			// console.log(chatMessages);

			// 会話履歴データが存在する場合のみ、リストに追加
			if (this.chatMessages != "") {
				// チャット画面に表示するために、CosmosDBから取得したデータを1つずつmessages(リスト型)に代入
				this.chatMessages.forEach((msg) => {
					// グラフ描画用のデータが格納されている場合はグラフのデータをセット
					// ※CosmosDBから返ってくるデータの配列の長さが1つの場合にはグラフを表示させない(2つ以上でグラフを表示)
					if (msg.graphData != null && msg.graphData.length > 1) {
						// グラフ描画の準備
						// console.log("msg.graphType", msg.graphType);
						// グラフをセット
						this.setGraph(msg.graphType);
						// グラフ表示用の変数に値をセット(あくまでグラフ描画の準備だけ)
						this.prepareChartData(
							msg.graphData,
							msg.graphType,
							msg.question ? msg.question.text : this.chatMessages[this.chatMessages.indexOf(msg) - 1]?.question?.text
						);
						// console.log("グラフの座標セット完了");

						// 元々のチャットデータを画面表示用のリストに追加
						this.messages.push(msg);
						// console.log("リストに追加途中のメッセージリスト", this.messages);
						// console.log("リストに追加完了");

						// グラフのデータを画面表示用のリストの同じ要素に再追加

						// 円グラフを2つ算出するパターンの場合には、messagesの配列に格納させるパラメーターを変更
						if (msg.graphType == "pietwospan") {
							// prepareChartData 内で push した範囲を取得してまとめて代入
							const { start, end } = this.lastPieChartRange;
							const idxList = Array.from({ length: end - start + 1 }, (_, k) => start + k);

							// グラフ種別を「pie」に変更
							msg.graphType = "pie";
							// 複数円グラフが描画される時に表示する「年-月」表示をセット
							msg.dayName = idxList.map((i) => this.chart.graphArrayData[i].dayName);
							// グラフ描画の際のX軸の値を2グラフ分セット(値が返ってきていない場合はnullでセット)
							msg.options = idxList.map((i) => this.chart.graphArrayData[i].options);
							// グラフ描画の際のY軸の値を2グラフ分セット(値が返ってきていない場合はnullでセット)
							msg.series = idxList.map((i) => this.chart.graphArrayData[i].series);
							// トマトサイズごとのグラフ複数描画用のフラグをオン
							// ※ 複数の円グラフ描画 or サイズごとの縦棒グラフ表示時のみ「true」にしている
							msg.isTomatoSizeTwoSpan = true;
							// console.log("データ読み込み時もグラフの複数描画用にパラメーターを追加します");
						} else {
							msg.dayName = "";
							// グラフ描画の際のX軸の値をセット(値が返ってきていない場合はnullでセット)
							msg.options = [this.chart.graphArrayData[this.graphIndex].options];
							// グラフ描画の際のY軸の値をセット(値が返ってきていない場合はnullでセット)
							msg.series = [this.chart.graphArrayData[this.graphIndex].series];
							msg.isTomatoSizeTwoSpan = false;
							// console.log("単体グラフ表示用として、パラメーターを今まで通りにセット");
							// console.log("単体グラフ表示時のgraphArraydata", this.chart.graphArrayData[this.graphIndex]);
							// console.log("単体グラフ表示時のmessages", this.messages);
						}
						// console.log("座標の指定完了");
						// console.log("座標指定完了時のグラフインデックス", this.graphIndex);
						// console.log("グラフデータが存在します");
					}
					// 返ってきたデータの中にグラフデータが存在しない場合には、そのままグラフデータ以外をリストに追加
					else {
						// 元々のチャットデータを画面表示用のリストに追加
						this.messages.push(msg);
						// console.log("グラフデータが存在しません");
					}
				});
				// console.log("処理完了、現在の配列の中", this.messages);
				// console.log("リスト追加後の中身", this.chart.graphArrayData);
				// console.log("今のセッションで生成中のグラフの個数", this.graphIndex + 1);
			}
			// 初回、Loading画面を非表示にする
			this.setLoadingFalse();
			// console.log("データの読み込み完了");
		},
		// グラフの再描画(グラフ種別判断ボタン用)
		// ※ サイドバーが開いている状態のみ実行
		// 最新のデータで再描画を行う
		async repaintGraph() {
			// 一度、初回のデータを全て削除
			this.messages.splice(0);
			// グラフデータ格納用のリストとそのリストインデックスをリセット
			this.resetGraphArray();
			// console.log("再描画時のgraphIndex", this.graphIndex);

			// 初期メッセージの二重追加ガード
			// chatMessagesの先頭が既に初期メッセージなら追加しない
			const needIntro = !(
				Array.isArray(this.chatMessages) &&
				this.chatMessages.length > 0 &&
				this.chatMessages[0]?.answer?.text === "質問したい事項を入力してください。"
			);
			if (needIntro) {
				this.messages.push({
					question: null,
					answer: { text: "質問したい事項を入力してください。", type: "bot" },
					imageUrl: null,
					graphType: null,
					options: null,
					series: null,
				});
			}
			// console.log("再描画の設定をする前のchatMessages", this.chatMessages);

			// 会話履歴データが存在する場合のみ、リストに追加
			if (this.chatMessages != "") {
				// DBから取得してきたデータ(questionとanswerが1セットになっているもの) or リストに都度追加して取得したデータ(question or answerのどちらかがかけている)の
				// 判断用インデックスを宣言
				// 初回は「-1」で宣言
				let conversationDataJudgeIndex = -1;

				// チャット画面に表示するために、CosmosDBから取得したデータを1つずつmessages(リスト型)に代入
				this.chatMessages.forEach((msg) => {
					// 1つデータを受け取るごとに何番目のデータか判断
					conversationDataJudgeIndex += 1;

					// グラフ描画用のデータが格納されている場合はグラフのデータをセット
					// ※CosmosDBから返ってくるデータの配列の長さが1つの場合にはグラフを表示させない(2つ以上でグラフを表示)
					if (msg.graphData != null && msg.graphData.length > 1) {
						// グラフ描画の準備

						// 複数円グラフ or サイズごとの縦棒グラフからのグラフ種別切り替えボタン押下時でない場合
						if (msg.graphType != "pie" && msg.graphType != "pietwospan") {
							// グラフをセット
							this.setGraph(msg.graphType);
						}
						// 円グラフ1つの場合の再描画処理
						else if (msg.graphType == "pie" && !msg.isTomatoSizeTwoSpan) {
							// グラフをセット
							this.setGraph(msg.graphType);

							// questionにデータが存在している場合
							// ※ CosmosDBから会話履歴のデータ一式を取得した場合(questionとanswerが1セットになっている時)
							if (msg.question != null) {
								// グラフ表示用の変数をセット
								this.prepareChartData(msg.graphData, msg.graphType, msg.question.text);
							}
							// questionではなく、answerにデータが存在している場合
							// ※ CosmosDBから会話履歴のデータ一式を取得せず、1会話ごとに1つずつリストへ追加している場合
							else {
								this.prepareChartData(msg.graphData, msg.graphType, this.chatMessages[conversationDataJudgeIndex - 1].question.text);
							}
						}

						// questionにデータが存在している場合
						// ※ CosmosDBから会話履歴のデータ一式を取得した場合(questionとanswerが1セットになっている時)
						if (msg.question != null && msg.graphType != "pie" && msg.graphType != "pietwospan") {
							// グラフ表示用の変数に値をセット(あくまでグラフ描画の準備だけ)
							this.prepareChartData(msg.graphData, msg.graphType, msg.question.text);
						}
						// questionではなく、answerにデータが存在している場合
						// ※ CosmosDBから会話履歴のデータ一式を取得せず、1会話ごとに1つずつリストへ追加している場合
						// (questionとanswerが1セットになっておらず、バラバラになっている状態の時)
						else if (msg.question == null && msg.graphType != "pie" && msg.graphType != "pietwospan") {
							// console.log("nullのため、1つ手前の質問からデータを取得します");
							// console.log("現時点でのconversationDataJudgeIndex", conversationDataJudgeIndex);
							// console.log("1つ手前の質問", this.chatMessages[conversationDataJudgeIndex - 1].question.text);

							// グラフ表示用の変数に値をセット(あくまでグラフ描画の準備だけ)
							// 1つ前のリスト(ここで取得したリストの中のanswerに対するquestion)からquestionを取得
							this.prepareChartData(msg.graphData, msg.graphType, this.chatMessages[conversationDataJudgeIndex - 1].question.text);
						}

						// 元々のチャットデータを画面表示用のリストに追加
						this.messages.push(msg);
						// console.log("元々のチャットデータを画面表示用のリストに追加", this.messages);

						// グラフのデータを画面表示用のリストの同じ要素に再追加

						// 円グラフが2つ表示され、その後にグラフ種別選択ボタンで縦棒グラフを選択した場合はもとの文字列(bar)になおしてサイズごとの縦棒グラフを再描画
						if (msg.graphType == "pietobar" && msg.isTomatoSizeTwoSpan) {
							// console.log("サイズごとのトマトサイズ用の縦棒グラフを再描画します");

							// dayNameの中身が入っている場合(複数円グラフ出力で代入されていた場合)
							if (msg.dayName != "") {
								// 縦棒グラフで各サイズごとに表示する場合はdayNameを空にする
								msg.dayName = "";
							}
							msg.graphType = "bar";
							// console.log("barに変更しました");

							// グラフ描画の際のX軸の値をセット(値が返ってきていない場合はnullでセット)
							msg.options = [this.chart.graphArrayData[this.graphIndex].options];
							// グラフ描画の際のY軸の値をセット(値が返ってきていない場合はnullでセット)
							msg.series = [this.chart.graphArrayData[this.graphIndex].series];
							msg.isTomatoSizeTwoSpan = true;

							// console.log("円グラフから縦棒グラフパターン、処理完了");
							// console.log("円グラフから縦棒グラフパターン、処理完了時のgraphIndex", this.graphIndex);
						}
						// 複数の円グラフ再描画時
						else if ((msg.graphType == "pie" || msg.graphType == "pietwospan") && msg.isTomatoSizeTwoSpan) {
							// "pietwospan" は prepareChartData() で動的 push 済み
							this.setGraph("pietwospan"); // 必要なら何もしない or ガード
							// 質問テキストあり/なしは元ロジックに合わせて prepareChartData を呼ぶ
							if (msg.question != null) {
								this.prepareChartData(msg.graphData, "pietwospan", msg.question.text);
							} else {
								this.prepareChartData(msg.graphData, "pietwospan", this.chatMessages[conversationDataJudgeIndex - 1].question.text);
							}
							const { start, end } = this.lastPieChartRange;
							const idxList = Array.from({ length: end - start + 1 }, (_, k) => start + k);
							msg.graphType = "pie";
							msg.dayName = idxList.map((i) => this.chart.graphArrayData[i].dayName);
							msg.options = idxList.map((i) => this.chart.graphArrayData[i].options);
							msg.series = idxList.map((i) => this.chart.graphArrayData[i].series);
							msg.isTomatoSizeTwoSpan = true;
						} else {
							// console.log("その他のグラフを再描画します");

							// グラフ描画の際の「年-月」表示を非表示
							msg.dayName = "";

							// グラフ描画の際のX軸の値をセット(値が返ってきていない場合はnullでセット)
							msg.options = [this.chart.graphArrayData[this.graphIndex].options];
							// グラフ描画の際のY軸の値をセット(値が返ってきていない場合はnullでセット)
							msg.series = [this.chart.graphArrayData[this.graphIndex].series];

							// 複数シリーズからの再描画でない場合のみ、falseにする
							// ※ セーフティー
							if (!msg.isTomatoSizeTwoSpan) {
								msg.isTomatoSizeTwoSpan = false;
							}
							// console.log("その他パターン、処理完了");
						}
						// console.log("グラフ用のデータをリストに再追加");
						// console.log("messagesの全リスト", this.messages);
					}
					// 返ってきたデータの中にグラフデータが存在しない場合には、そのままグラフデータ以外をリストに追加
					else {
						// 元々のチャットデータを画面表示用のリストに追加
						this.messages.push(msg);
					}
				});
				// console.log("現時点でのgraphArrayData", this.chart.graphArrayData);
				// console.log("現時点でのgraphIndex", this.graphIndex);
			}
			await this.scrollToBottom({ smooth: false, retries: 8, force: true });
			// console.log("グラフを再描画します");
		},
		// チャット履歴削除画面を表示
		showConfirmDialog() {
			this.isDialogVisible = true;
		},
		// チャット履歴削除画面を非表示
		closeConfirmDialog() {
			this.isDialogVisible = false;
		},
		// 「SideBar.vue」からセッションIDを受け取る
		getSessionId(sessionId) {
			// セッションIDをバックアップ
			this.conversation_id = sessionId;
			// console.log("セッションIDを受け取りました", this.conversation_id);
		},
		// ログイン中のユーザーID、セッションIDとセットで登録されている会話データを全て削除
		deleteSession() {
			// バックエンドの接続先を指定
			const api_url = this.function_ip + "&action=DeleteConversation";

			authFetch(api_url, {
				method: "POST",
				headers: {
					// JSON形式で送信
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					// セッションIDをstring型に変換してリクエストボディに含める
					sessionId: this.conversation_id,
				}),
			})
				.then((response) => {
					if (response.ok) {
						alert("チャット履歴を削除しました。");

						// サイドバーが表示されている時のみ、最新のデータを読み込み表示を更新
						if (this.showSideBar) {
							// データ削除時には最新のデータを取得するために、再度フラグをtrueにする
							this.isInitialize = true;
							// サイドバーの情報を最新に更新
							// SideBar.vueのfetchConversationsメソッドを呼び出す
							this.$refs.sidebar.fetchConversations();
						}
					} else {
						alert("チャット履歴の削除が失敗しました。");
					}
				})
				.catch((error) => {
					alert("通信エラーが発生しました。接続先を確認してください。");
					console.error("Error:", error);
				});
		},
		// ゴミ箱ボタンで選択された一部の会話データのみを削除
		deleteSomeConversationData(index) {
			// console.log("index", index);

			// リクエスト時に送るインデックスを作成
			const repair_index = index - 1;
			// console.log("repair_index", repair_index);

			// バックエンドの接続先を指定
			const api_url = this.function_ip + "&action=DeleteSomeConversation";

			authFetch(api_url, {
				method: "POST",
				headers: {
					// JSON形式で送信
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					// 修正後のインデックスをstring型に変換してリクエストボディに含める
					index: repair_index,
					// セッションIDをstring型に変換してリクエストボディに含める
					sessionId: this.conversation_id,
				}),
			})
				.then((response) => {
					if (response.ok) {
						alert("一部のチャット履歴を削除しました。");

						// サイドバーが表示されている時のみ、最新のデータを読み込み表示を更新
						if (this.showSideBar) {
							this.$refs.sidebar.fetchConversations();
						} else {
							// サイドバーが閉じている時はデータの自動更新ができないため、AIChat.vue側のリストを削除
							this.deleteSomeListData(index);
						}
					} else {
						alert("一部のチャット履歴の削除が失敗しました。");
					}
				})
				.catch((error) => {
					alert("通信エラーが発生しました。接続先を確認してください。");
					console.error("Error:", error);
				});
		},
		// 初回表示フラグをfalseにする
		initializeFalse() {
			this.isInitialize = false;
		},
		// SideBar.vue側のインデックスのバックアップ
		indexBackup(index) {
			this.activeindex_backup = index;
			// console.log("インデックスをバックアップしました");
		},
		// 一部会話履歴の削除時における、ローカルでのリスト削除処理
		deleteSomeListData(index) {
			// 格納されているリストの内容によって、削除するインデックスを分岐

			// リストの中身として、質問と回答がセットで格納されている場合
			// ※つまり、ComosDBからデータを取得後、CosmosDBのリストの形で自動でデータ追加されたケースの場合
			if (this.messages[index].question && this.messages[index].answer) {
				// console.log("CosmosDBから取得したデータです");

				// optionsの中身が空でない場合(DBデータが格納されている場合)
				if (this.messages[index].options != undefined) {
					// optionsに格納されているデータの数を確認
					const graphDataNumber = this.messages[index].options.length;
					// console.log("messagesの中に格納されているoptionsの数", this.messages[index].options.length);

					// 該当グラフを削除した分、graphIndexとgraphArrayDataを削除する
					this.deleteGraphIndexData(graphDataNumber, index - 1);
				}
				// 対象のリスト1つのみを削除
				this.messages.splice(index, 1);
			}
			// questionのみ値が存在する場合
			// ※つまり、サイドバーを閉じた状態で新たにGUIからプロンプトが投げられた場合(question or answerのどちらかがnulになっている状態)
			else {
				// console.log("ローカルでリストに追加したデータです");

				// optionsの中身が空でない場合(DBデータが格納されている場合)
				if (this.messages[index + 1].options != undefined) {
					// optionsに格納されているデータの数を確認
					const graphDataNumber = this.messages[index + 1].options.length;
					// console.log("messagesの中に格納されているoptionsの数", this.messages[index + 1].options.length);

					// 該当グラフを削除した分、graphIndexとgraphArrayDataを削除する
					this.deleteGraphIndexData(graphDataNumber, index - 1);
				}
				// 対象のリスト2つ両方削除
				this.messages.splice(index, 2);
			}
			// console.log("現時点でのgraphIndex", this.graphIndex);
			// console.log("現時点でのgraphArraydata", this.chart.graphArrayData);
			// console.log("現時点でのmessages", this.messages);
		},
		// 会話履歴の一部削除時、optionsの数によってgraphIndexとgrahArrayDataの中身を削除した数だけ削除
		deleteGraphIndexData(optionsLength, index) {
			// 返ってきたmessagesの中のoptionsデータの中身が1つの場合
			if (optionsLength == 1) {
				// graphIndexを1つ減らす
				this.graphIndex -= 1;

				// リストが存在する場合のみ、中身を削除
				if (index >= 0 && index < this.chart.graphArrayData.length) {
					// 削除したグラフ部分のgraphArrayDataを1つ削除する
					this.chart.graphArrayData.splice(index, 1);
				}
			}
			// 返ってきたmessagesの中のoptionsデータの中身が2つの場合
			else {
				// graohIndexを2つ減らす
				this.graphIndex -= 2;
				// リストが存在する場合のみ、中身を削除
				if (index >= 0 && index < this.chart.graphArrayData.length) {
					// 削除したグラフ部分のgraphArrayDataを2つ削除する
					this.chart.graphArrayData.splice(index, 2);
				}
			}
		},
		// グラフ作成用のデータを取得
		prepareChartData(data, graphType, userPrompt) {
			// console.log("Azure CosmosDBから受け取ったdata", data);
			// console.log("受け取ったgraphType", graphType);

			// バックエンドから返ってきたグラフ種別が「折れ線グラフ」の場合
			if (graphType == "line") {
				// console.log("これから折れ線グラフを出力");

				// 糖度データ問い合わせ確認(bed番号が返ってきている場合でも一緒に判断)
				// dataがnullではなく、配列である、かつ「date」「brix」「bed_number」が両方ともundefinedではない場合にtrueを返して折れ線グラフを生成する
				const hasBrixData =
					Array.isArray(data) && data.some((item) => item.date !== undefined && item.brix !== undefined && item.bed_number !== undefined);
				// console.log("hasBrixData", hasBrixData);

				// 計測データ問い合わせ確認
				// dataがnullではなく、配列である、かつ「date」「date_item_id_seed_id」が両方ともundefinedではない場合にtrueを返して折れ線グラフを生成する
				const hasMeasureData = Array.isArray(data) && data.some((item) => item.date !== undefined && item.date_item_id_seed_id !== undefined);
				// console.log("hasMeasureData", hasMeasureData);

				// 計測データ中の中でも「SPAD」データが入っている場合には、trueを返す
				const hasMeasureSpadData =
					Array.isArray(data) &&
					data.some((item) => item.date !== undefined && item.date_item_id_seed_id !== undefined && item.quantity_4 !== undefined);
				// console.log("hasMeasureSpadData", hasMeasureSpadData);

				// 計測データ中の中でも、灌水量データ(before、afterの両方)が返ってきている場合には、trueを返す
				const hasMeasureIrrigationBeforeAfterData =
					Array.isArray(data) && data.some((item) => item.date != undefined && item.before != undefined && item.after != undefined);
				// console.log("hasMeasureIrrigationBeforeAfterData", hasMeasureIrrigationBeforeAfterData);

				// 計測データ中の中でも、灌水量データ(after)が返ってきている場合には、trueを返す
				const hasMeasureIrrigationAfterData =
					Array.isArray(data) && data.some((item) => item.date !== undefined && item.before == undefined && item.after !== undefined);
				// console.log("hasMeasureIrrigationAfterData", hasMeasureIrrigationAfterData);

				// 養液データのデータ問い合わせ確認
				const hasNutrientSolutionData =
					Array.isArray(data) &&
					data.some(
						(item) =>
							item.date !== undefined &&
							item.bed_number != undefined &&
							(item.ca != undefined || item.k != undefined || item.no3 != undefined || item.ph != undefined || item.ec != undefined)
					);
				// console.log("hasNutrientSolutionData", hasNutrientSolutionData);

				// 収穫量データの問い合わせ確認
				const hasCropYeildData = Array.isArray(data) && data.some((item) => item.date !== undefined && item.crop_yeild != undefined);
				// console.log("hasCropYeildData", hasCropYeildData);

				// 総収量データの問い合わせ確認
				const hasWeightData =
					Array.isArray(data) && data.some((item) => item.date !== undefined && item.class != undefined && item.weight != undefined);
				// console.log("hasWeightData", hasWeightData);

				// 総収量（日次）データ判定：date + weight（classなし）
				const hasGrossHarvestDataSimple =
					Array.isArray(data) && data.some((item) => item.date !== undefined && item.weight !== undefined && item.class === undefined);

				// 収穫量データが返ってきている場合
				if (hasCropYeildData) {
					// データからX軸とY軸の情報を取得
					data.forEach((item) => {
						//アイテムの中身によって、座標に代入する値を制御
						this.dataHarvestBranching(item);

						// 「crop_yeild」のデータが存在する場合のみ、グラフの設定に座標をセット
						if (item.crop_yeild != null) {
							// その他データ描画時
							// X軸をセット
							this.chart.graphArrayData[this.graphIndex].options.xaxis.categories.push(this.x_value);
							// Y軸をセット
							this.chart.graphArrayData[this.graphIndex].series[0].data.push(
								// 小数第2位までデータをインプット
								parseFloat(this.y_value).toFixed(2)
							);
						}
					});
					// console.log("収穫量グラフを描画");
				} else if (hasGrossHarvestDataSimple) {
					const slot = this.chart.graphArrayData[this.graphIndex];

					// 'YYYY-MM-DD' → 'MM-DD' を安全に取り出す（文字列スライスで確実に）
					const monthDayKey = (dateStr) => {
						if (typeof dateStr !== "string") return null;
						const m = dateStr.slice(5, 7);
						const d = dateStr.slice(8, 10);
						if (!m || !d) return null;
						return `${m}-${d}`; // 例: '12-27'
					};

					// 1) 両年の MM-DD のユニオンカテゴリ（昇順）を作成
					const mdSet = new Set();
					(Array.isArray(data) ? data : []).forEach((item) => {
						const md = monthDayKey(item.date);
						if (md) mdSet.add(md);
					});
					const categories = Array.from(mdSet).sort((a, b) => {
						const [am, ad] = a.split("-").map(Number);
						const [bm, bd] = b.split("-").map(Number);
						return am === bm ? ad - bd : am - bm;
					});

					// 2) カテゴリ → 連番インデックスのマップ
					const indexByMd = Object.fromEntries(categories.map((md, i) => [md, i]));

					// 3) 年ごとの { md → weight } を構築
					const byYear = {};
					data.forEach((item) => {
						const md = monthDayKey(item.date);
						if (!md) return;
						const year = item.date.slice(0, 4); // 'YYYY'
						const v = Number(item.weight);
						if (!Number.isFinite(v)) return;
						(byYear[year] ||= []).push({ md, value: Number(v.toFixed(2)) });
					});

					// 4) series を { x: index, y: 値 } で作る（★ null を使わない）
					const yearsSorted = Object.keys(byYear).sort(); // ['2022','2023'] 等
					const palette = ["#008FFB", "#00E396", "#FEB019", "#775DD0", "#FF4560", "#3F51B5", "#2B908F", "#F9A3A4", "#90EE7E", "#FA4443"];

					slot.series = yearsSorted.map((year) => {
						// 年内の点を MM-DD 昇順で並べ、インデックスに変換
						const points = byYear[year]
							.slice()
							.sort((a, b) => {
								const [am, ad] = a.md.split("-").map(Number);
								const [bm, bd] = b.md.split("-").map(Number);
								return am === bm ? ad - bd : am - bm;
							})
							.map((p) => ({ x: indexByMd[p.md], y: p.value }));
						return { name: year, data: points };
					});

					// 5) グラフ設定：type を明示
					slot.options.chart = { type: "line", toolbar: { show: false } };

					// 6) X軸は「数値軸」でインデックスを表示。ラベルはインデックス→MM/DD に変換
					slot.options.xaxis = slot.options.xaxis || {};
					slot.options.xaxis.type = "numeric"; // ← 重要：numeric にする
					slot.options.xaxis.min = 0;
					slot.options.xaxis.max = categories.length - 1; // 範囲を固定
					slot.options.xaxis.tickAmount = Math.min(15, categories.length - 1);
					slot.options.xaxis.labels = {
						rotate: -30,
						formatter: (idx) => {
							if (idx == null) return "";
							const raw = categories[idx] ?? "";
							const s = typeof raw === "string" ? raw : String(raw);
							return s.includes("-") ? s.replace("-", "/") : s; // '12-27' → '12/27'
						},
					};

					// 7) 線とマーカー（null を使っていないので確実に繋がる）
					slot.options.colors = yearsSorted.map((_, i) => palette[i % palette.length]);

					// 8) ツールチップ：x はインデックスで渡る → カテゴリ配列からラベルに変換
					slot.options.tooltip = {
						enabled: true,
						theme: "dark",
						shared: false,
						x: {
							formatter: (val) => {
								const raw = categories[val] ?? "";
								const s = typeof raw === "string" ? raw : String(raw);
								return s.includes("-") ? s.replace("-", "/") : s;
							},
						},
						y: {
							formatter: (val) => {
								const v = Number.isFinite(Number(val)) ? Number(val) : 0;
								return `${v.toFixed(2)} kg`;
							},
						},
					};
				}

				// 総収量データが返ってきている場合
				else if (hasWeightData) {
					// 各classごとのデータを格納するオブジェクトを初期化
					const groupedData = {};

					data.forEach((item) => {
						// 「2S_3L以上合計」 or 「総収量」のラベルが存在する場合は、このラベルデータだけ描画しない
						if (item.class == "2S_3L以上合計" || item.class == "総収量") {
							// console.log("「2S_3L以上合計」 or 「総収量」のラベルがあるため、スキップ");
							return;
						}

						//アイテムの中身によって、座標に代入する値を制御
						this.dataBranching(item);

						// groupedDataを更新
						if (!groupedData[item.class]) {
							groupedData[item.class] = { name: item.class, data: [] };
						}

						// X軸とY軸に必要な値を追加
						if (this.x_value && this.y_value !== undefined) {
							// X軸のカテゴリーに日付を追加(重複を避ける)
							if (this.x_value && this.chart.graphArrayData[this.graphIndex].options.xaxis.categories.indexOf(this.x_value) === -1) {
								this.chart.graphArrayData[this.graphIndex].options.xaxis.categories.push(this.x_value);
							}
							// データを追加
							groupedData[item.class].data.push({
								date: this.x_value,
								value: parseFloat(this.y_value),
							});
						}
					});

					// 各classごとのデータをchart.seriesに変換
					Object.keys(groupedData).forEach((item) => {
						const seriesData = this.chart.graphArrayData[this.graphIndex].options.xaxis.categories.map((date) => {
							const dataPoint = groupedData[item].data.find((d) => d.date === date);

							//データがない場合はnullを返す
							return dataPoint ? dataPoint.value : null;
						});
						// console.log("seriesData", seriesData);
						this.chart.graphArrayData[this.graphIndex].series.push({
							name: groupedData[item].name,
							data: seriesData,
						});
					});

					// seriesが空でない場合のみ、そのデータを表示(有効なデータ点を持つ系列だけが表示され、〇表示もデータがある場合のみ表示される)
					// データポイントの中にnullが含まれる場合、その系列を削除
					// this.chart.graphArrayData[this.graphIndex].series = this.chart.graphArrayData[this.graphIndex].series.filter((series) =>
					// 	series.data.some((value) => value !== null)
					// );
					const currentSeries = this.chart.graphArrayData?.[this.graphIndex]?.series ?? [];
					this.chart.graphArrayData[this.graphIndex].series = currentSeries.filter((series) => {
						// ① 折れ線/棒の系列オブジェクト { name, data: [...] } の場合
						if (Array.isArray(series?.data)) {
							return series.data.some((v) => v !== null && v !== undefined);
						}
						// ② 円グラフなどで series が「配列そのもの」の場合
						if (Array.isArray(series)) {
							return series.some((v) => v !== null && v !== undefined);
						}
						// ③ どれにも当てはまらない（不正形）→除外
						return false;
					});
					// console.log("総収量の折れ線グラフを描画");
				}
				// 計測データ情報(growth_data)が返ってきている場合
				else if (hasMeasureData) {
					// 「平均」のワードが入っている、かつSPAD値のデータが返ってきている場合には、各計測日の全苗番号の平均を算出
					if (this.judgePromptAverageWord(userPrompt) && hasMeasureSpadData) {
						// 各日付ごとのSPAD値の合計を算出
						const averageData = data.reduce((acc, curr) => {
							const date = curr.date;
							const quantity = parseFloat(curr.quantity_4);

							if (!acc[date]) {
								acc[date] = { total: 0, count: 0 };
							}

							acc[date].total += quantity;
							acc[date].count += 1;

							return acc;
						}, {});
						// console.log("averageData", averageData);

						// 各日付ごとにSPAD値の平均を算出
						const averageArray = Object.keys(averageData).map((date) => {
							const { total, count } = averageData[date];
							return { date, average: (total / count).toFixed(1) };
						});
						// console.log("averageArray", averageArray);

						// グラフデータの準備
						this.chart.graphArrayData[this.graphIndex].options.xaxis.categories = averageArray.map((item) => item.date);
						this.chart.graphArrayData[this.graphIndex].series = [
							{
								name: "各日付ごとの全SPAD値の平均",
								data: averageArray.map((item) => parseFloat(item.average)),
							},
						];

						// console.log("各日付のSPAD値の平均をグラフに出力");
					}
					// そうでない場合には、各苗番号ごとのデータをグラフに描画
					else {
						// 各bed_numberごとのデータを格納するオブジェクトを初期化
						const groupedData = {};
						let index = -1;

						data.forEach((item) => {
							// 配列の中身取得用のインデックスを用意
							index += 1;
							// console.log("index", index);

							//アイテムの中身によって、座標に代入する値を制御
							this.dataBranching(item);

							// インデックスに沿って、配列の要素を取得

							// "date_item_id_seed_id"の値を取得
							const dateItemIdSeed = data[index];
							const getDateItemIdSeed = dateItemIdSeed["date_item_id_seed_id"];
							// console.log("取り出した加工前の苗番号", getDateItemIdSeed);

							// 最後の'*'の位置を取得
							const lastAsteriskIndex = getDateItemIdSeed.lastIndexOf("*");
							// console.log("最後の*の位置", lastAsteriskIndex);

							// 日付部分を削除して、新しい値を作成

							// '*'以降の文字列を取得し、トリミング
							const newId = getDateItemIdSeed
								.substring(lastAsteriskIndex + 1)
								.trim()
								.replace(" ", "-");
							// const newId = getDateItemIdSeed.split("*")[1].trim().replace(" ", "-");
							// console.log("加工後の苗番号", newId);

							// groupedDataを更新
							if (!groupedData[newId]) {
								groupedData[newId] = { name: newId, data: [] };
							}

							// X軸とY軸に必要な値を追加
							if (this.x_value && this.y_value !== undefined) {
								// X軸のカテゴリーに日付を追加(重複を避ける)
								if (this.x_value && this.chart.graphArrayData[this.graphIndex].options.xaxis.categories.indexOf(this.x_value) === -1) {
									this.chart.graphArrayData[this.graphIndex].options.xaxis.categories.push(this.x_value);
								}
								// データを追加
								groupedData[newId].data.push({
									date: this.x_value,
									value: parseFloat(this.y_value),
								});
							}
						});

						// 各bed_numberごとのデータをchart.seriesに変換
						Object.keys(groupedData).forEach((bed_number) => {
							const seriesData = this.chart.graphArrayData[this.graphIndex].options.xaxis.categories.map((date) => {
								const dataPoint = groupedData[bed_number].data.find((d) => d.date === date);

								//データがない場合はnullを返す
								return dataPoint ? dataPoint.value : null;
							});
							this.chart.graphArrayData[this.graphIndex].series.push({
								name: groupedData[bed_number].name,
								data: seriesData,
							});
						});

						// seriesが空でない場合のみ、そのデータを表示(有効なデータ点を持つ系列だけが表示され、〇表示もデータがある場合のみ表示される)
						// データポイントの中にnullが含まれる場合、その系列を削除
						// this.chart.graphArrayData[this.graphIndex].series = this.chart.graphArrayData[this.graphIndex].series.filter((series) =>
						// 	series.data.some((value) => value !== null)
						// );
						const currentSeries = this.chart.graphArrayData?.[this.graphIndex]?.series ?? [];
						this.chart.graphArrayData[this.graphIndex].series = currentSeries.filter((series) => {
							// ① 折れ線/棒の系列オブジェクト { name, data: [...] } の場合
							if (Array.isArray(series?.data)) {
								return series.data.some((v) => v !== null && v !== undefined);
							}
							// ② 円グラフなどで series が「配列そのもの」の場合
							if (Array.isArray(series)) {
								return series.some((v) => v !== null && v !== undefined);
							}
							// ③ どれにも当てはまらない（不正形）→除外
							return false;
						});
						// console.log("各苗番号のデータをそのままグラフに出力");
					}
					// console.log("計測データのグラフを描画");
				}
				// 養液データが返ってきている場合
				else if (hasNutrientSolutionData) {
					// 各bed_numberごとのデータを格納するオブジェクトを初期化
					const groupedData = {};

					data.forEach((item) => {
						//アイテムの中身によって、座標に代入する値を制御
						this.dataBranching(item);

						// groupedDataを更新
						if (!groupedData[item.bed_number]) {
							groupedData[item.bed_number] = { name: item.bed_number, data: [] };
						}

						// X軸とY軸に必要な値を追加
						if (this.x_value && this.y_value !== undefined) {
							// X軸のカテゴリーに日付を追加(重複を避ける)
							if (this.x_value && this.chart.graphArrayData[this.graphIndex].options.xaxis.categories.indexOf(this.x_value) === -1) {
								this.chart.graphArrayData[this.graphIndex].options.xaxis.categories.push(this.x_value);
							}

							// データを追加
							groupedData[item.bed_number].data.push({
								date: this.x_value,
								value: parseFloat(this.y_value),
							});
						}
					});

					// 各bed_numberごとのデータをchart.seriesに変換
					Object.keys(groupedData).forEach((bed_number) => {
						const seriesData = this.chart.graphArrayData[this.graphIndex].options.xaxis.categories.map((date) => {
							const dataPoint = groupedData[bed_number].data.find((d) => d.date === date);

							//データがない場合はnullを返す
							return dataPoint ? dataPoint.value : null;
						});
						this.chart.graphArrayData[this.graphIndex].series.push({
							name: groupedData[bed_number].name,
							data: seriesData,
						});
					});

					// seriesが空でない場合のみ、そのデータを表示(有効なデータ点を持つ系列だけが表示され、〇表示もデータがある場合のみ表示される)
					// データポイントの中にnullが含まれる場合、その系列を削除
					// this.chart.graphArrayData[this.graphIndex].series = this.chart.graphArrayData[this.graphIndex].series.filter((series) =>
					// 	series.data.some((value) => value !== null)
					// );
					const currentSeries = this.chart.graphArrayData?.[this.graphIndex]?.series ?? [];
					this.chart.graphArrayData[this.graphIndex].series = currentSeries.filter((series) => {
						// ① 折れ線/棒の系列オブジェクト { name, data: [...] } の場合
						if (Array.isArray(series?.data)) {
							return series.data.some((v) => v !== null && v !== undefined);
						}
						// ② 円グラフなどで series が「配列そのもの」の場合
						if (Array.isArray(series)) {
							return series.some((v) => v !== null && v !== undefined);
						}
						// ③ どれにも当てはまらない（不正形）→除外
						return false;
					});
					// console.log("養液データのグラフを描画");
				}
				// 灌水量データが返ってきている場合(灌水量の変化量(after - before)に対する問い対応)
				else if (hasMeasureIrrigationBeforeAfterData) {
					// 各bed_numberごとのデータを格納するオブジェクトを初期化
					const groupedData = {};

					data.forEach((item) => {
						//アイテムの中身によって、座標に代入する値を制御
						this.dataBranching(item);

						// groupedDataを更新
						if (!groupedData[item.bed_number]) {
							groupedData[item.bed_number] = { name: item.bed_number, data: [] };
						}

						// X軸とY軸に必要な値を追加
						if (this.x_value && this.y_value !== undefined) {
							// X軸のカテゴリーに日付を追加(重複を避ける)
							if (this.x_value && this.chart.graphArrayData[this.graphIndex].options.xaxis.categories.indexOf(this.x_value) === -1) {
								this.chart.graphArrayData[this.graphIndex].options.xaxis.categories.push(this.x_value);
							}

							// データを追加
							groupedData[item.bed_number].data.push({
								date: this.x_value,
								value: parseFloat(this.y_value),
							});
						}
					});

					// 各bed_numberごとのデータをchart.seriesに変換
					Object.keys(groupedData).forEach((bed_number) => {
						const seriesData = this.chart.graphArrayData[this.graphIndex].options.xaxis.categories.map((date) => {
							const dataPoint = groupedData[bed_number].data.find((d) => d.date === date);

							//データがない場合はnullを返す
							return dataPoint ? dataPoint.value : null;
						});
						this.chart.graphArrayData[this.graphIndex].series.push({
							name: groupedData[bed_number].name,
							data: seriesData,
						});
					});

					// seriesが空でない場合のみ、そのデータを表示(有効なデータ点を持つ系列だけが表示され、〇表示もデータがある場合のみ表示される)
					// データポイントの中にnullが含まれる場合、その系列を削除
					// this.chart.graphArrayData[this.graphIndex].series = this.chart.graphArrayData[this.graphIndex].series.filter((series) =>
					// 	series.data.some((value) => value !== null)
					// );
					const currentSeries = this.chart.graphArrayData?.[this.graphIndex]?.series ?? [];
					this.chart.graphArrayData[this.graphIndex].series = currentSeries.filter((series) => {
						// ① 折れ線/棒の系列オブジェクト { name, data: [...] } の場合
						if (Array.isArray(series?.data)) {
							return series.data.some((v) => v !== null && v !== undefined);
						}
						// ② 円グラフなどで series が「配列そのもの」の場合
						if (Array.isArray(series)) {
							return series.some((v) => v !== null && v !== undefined);
						}
						// ③ どれにも当てはまらない（不正形）→除外
						return false;
					});
					// console.log("灌水量データの水位変化(after - before)グラフを描画");
				}
				// 灌水量データが返ってきている場合(灌水量データの推移の問い合わせが来た場合)
				else if (hasMeasureIrrigationAfterData) {
					// 各bed_numberごとのデータを格納するオブジェクトを初期化
					const groupedData = {};

					data.forEach((item) => {
						//アイテムの中身によって、座標に代入する値を制御
						this.dataBranching(item);

						// groupedDataを更新
						if (!groupedData[item.bed_number]) {
							groupedData[item.bed_number] = { name: item.bed_number, data: [] };
						}

						// X軸とY軸に必要な値を追加
						if (this.x_value && this.y_value !== undefined) {
							// X軸のカテゴリーに日付を追加(重複を避ける)
							if (this.x_value && this.chart.graphArrayData[this.graphIndex].options.xaxis.categories.indexOf(this.x_value) === -1) {
								this.chart.graphArrayData[this.graphIndex].options.xaxis.categories.push(this.x_value);
							}

							// データを追加
							groupedData[item.bed_number].data.push({
								date: this.x_value,
								value: parseFloat(this.y_value),
							});
						}
					});

					// 各bed_numberごとのデータをchart.seriesに変換
					Object.keys(groupedData).forEach((bed_number) => {
						const seriesData = this.chart.graphArrayData[this.graphIndex].options.xaxis.categories.map((date) => {
							const dataPoint = groupedData[bed_number].data.find((d) => d.date === date);

							//データがない場合はnullを返す
							return dataPoint ? dataPoint.value : null;
						});
						this.chart.graphArrayData[this.graphIndex].series.push({
							name: groupedData[bed_number].name,
							data: seriesData,
						});
					});

					// seriesが空でない場合のみ、そのデータを表示(有効なデータ点を持つ系列だけが表示され、〇表示もデータがある場合のみ表示される)
					// データポイントの中にnullが含まれる場合、その系列を削除
					// this.chart.graphArrayData[this.graphIndex].series = this.chart.graphArrayData[this.graphIndex].series.filter((series) =>
					// 	series.data.some((value) => value !== null)
					// );
					const currentSeries = this.chart.graphArrayData?.[this.graphIndex]?.series ?? [];
					this.chart.graphArrayData[this.graphIndex].series = currentSeries.filter((series) => {
						// ① 折れ線/棒の系列オブジェクト { name, data: [...] } の場合
						if (Array.isArray(series?.data)) {
							return series.data.some((v) => v !== null && v !== undefined);
						}
						// ② 円グラフなどで series が「配列そのもの」の場合
						if (Array.isArray(series)) {
							return series.some((v) => v !== null && v !== undefined);
						}
						// ③ どれにも当てはまらない（不正形）→除外
						return false;
					});
					// console.log("灌水量データ(変更後)のみ出力、グラフを描画");
				}
				// 糖度データが返ってきている場合
				else if (hasBrixData) {
					// ★ bar→line 切替時のみ：年ごとの折れ線（X=MM/DD）で重ね描き
					if (this.isBrixYearOverlay) {
						const slot = this.chart.graphArrayData[this.graphIndex];

						// 'YYYY-MM-DD' → 'MM-DD'
						const monthDayKey = (dateStr) => {
							if (typeof dateStr !== "string") return null;
							const m = dateStr.slice(5, 7);
							const d = dateStr.slice(8, 10);
							if (!m || !d) return null;
							return `${m}-${d}`;
						};

						// MM-DD ユニオン（昇順）
						const mdSet = new Set();
						(Array.isArray(data) ? data : []).forEach((item) => {
							if (item?.bed_number === "平均値") return; // 既存仕様に合わせて平均値行は除外
							const md = monthDayKey(item?.date);
							if (md) mdSet.add(md);
						});
						const categories = Array.from(mdSet).sort((a, b) => {
							const [am, ad] = a.split("-").map(Number);
							const [bm, bd] = b.split("-").map(Number);
							return am === bm ? ad - bd : am - bm;
						});
						const indexByMd = Object.fromEntries(categories.map((md, i) => [md, i]));

						// 年×月日で平均 Brix を集計（同日複数 bed は平均化）
						const yearlyAgg = {};
						data.forEach((item) => {
							if (item?.bed_number === "平均値") return;
							const md = monthDayKey(item?.date);
							if (!md) return;
							const year = String(item.date).slice(0, 4);
							const v = Number(item?.brix);
							if (!Number.isFinite(v)) return;
							yearlyAgg[year] ??= {};
							yearlyAgg[year][md] ??= { sum: 0, count: 0 };
							yearlyAgg[year][md].sum += v;
							yearlyAgg[year][md].count += 1;
						});

						// series を { x: index, y: 値 } で生成（null を使わず線を繋ぐ）
						const yearsSorted = Object.keys(yearlyAgg).sort();
						slot.series = yearsSorted.map((year) => {
							const mdAvgPairs = Object.entries(yearlyAgg[year]).map(([md, agg]) => ({
								md,
								value: Number((agg.sum / agg.count).toFixed(1)), // 小数1桁
							}));
							const points = mdAvgPairs
								.sort((a, b) => {
									const [am, ad] = a.md.split("-").map(Number);
									const [bm, bd] = b.md.split("-").map(Number);
									return am === bm ? ad - bd : am - bm;
								})
								.map((p) => ({ x: indexByMd[p.md], y: p.value }));
							return { name: year, data: points };
						});

						// グラフ設定：Xを数値軸にし、ラベル/ツールチップを MM/DD 表示
						slot.options.chart = { type: "line", toolbar: { show: false } };
						slot.options.xaxis = slot.options.xaxis || {};
						slot.options.xaxis.type = "numeric";
						slot.options.xaxis.min = 0;
						slot.options.xaxis.max = categories.length - 1;
						slot.options.xaxis.tickAmount = Math.min(15, categories.length - 1);
						slot.options.xaxis.labels = {
							rotate: -30,
							formatter: (idx) => {
								if (idx == null) return "";
								const raw = categories[idx] ?? "";
								const s = typeof raw === "string" ? raw : String(raw);
								return s.includes("-") ? s.replace("-", "/") : s; // '12-27' → '12/27'
							},
						};
						slot.options.tooltip = {
							enabled: true,
							theme: "dark",
							shared: false,
							x: {
								formatter: (val) => {
									const raw = categories[val] ?? "";
									const s = typeof raw === "string" ? raw : String(raw);
									return s.includes("-") ? s.replace("-", "/") : s;
								},
							},
							y: {
								formatter: (val) => {
									const v = Number.isFinite(Number(val)) ? Number(val) : 0;
									return `${v.toFixed(1)}`;
								},
							},
						};

						// 一度使ったらフラグを戻す
						this.isBrixYearOverlay = false;
						return; // 既存の平均/else へは落とさない
					}

					// ユーザープロンプトの中に、「平均」が含まれている場合
					if (this.judgePromptAverageWord(userPrompt)) {
						// 「平均」の質問 + 「苗番号」の指定が入っていた場合
						// 各苗番号ごとに各月で糖度の平均をだす
						if (this.judgePromptWord(userPrompt)) {
							// 各月の糖度平均を算出(苗番号ごとに各月の平均を算出)
							const monthlyData = {};

							// 各月の苗番号ごとの合計を算出
							data.forEach((item) => {
								if (item.bed_number != "平均値") {
									const month = item.date.substring(0, 7); // YYYY-MM
									const bedNumber = item.bed_number;
									const brix = parseFloat(item.brix);

									if (!monthlyData[month]) {
										monthlyData[month] = {};
									}

									if (!monthlyData[month][bedNumber]) {
										monthlyData[month][bedNumber] = { total: 0, count: 0 };
									}

									monthlyData[month][bedNumber].total += brix;
									monthlyData[month][bedNumber].count += 1;
								}
							});
							// console.log("各月の苗番号ごとの合計", monthlyData);

							const result = {};

							// 各月の苗番号ごとの平均を算出
							Object.keys(monthlyData).forEach((month) => {
								result[month] = {};
								Object.keys(monthlyData[month]).forEach((bedNumber) => {
									const averageBrix = (monthlyData[month][bedNumber].total / monthlyData[month][bedNumber].count).toFixed(1);
									result[month][bedNumber] = averageBrix;
								});
							});
							// console.log("各月の苗番号ごとの平均", result);

							const series = {};

							// Seriesを作成
							Object.keys(result).forEach((month) => {
								Object.keys(result[month]).forEach((bedNumber) => {
									if (!series[bedNumber]) {
										series[bedNumber] = {
											name: bedNumber,
											data: Array(Object.keys(result).length).fill(null),
										};
									}
									const monthIndex = Object.keys(result).indexOf(month);
									series[bedNumber].data[monthIndex] = parseFloat(result[month][bedNumber]);
								});
							});

							// X-axis categories
							const categories = Object.keys(result);
							// console.log("X軸にセットするデータ", categories);

							// Prepare series for ApexCharts
							const seriesArray = Object.values(series);
							// console.log("Y軸にセットするデータ", seriesArray);

							// X軸に日付(年/月)データを代入
							this.chart.graphArrayData[this.graphIndex].options.xaxis.categories = categories;
							// Y軸に各月の苗番号毎の平均糖度データを代入
							this.chart.graphArrayData[this.graphIndex].series = seriesArray;

							// console.log("各苗番号ごとの平均糖度を各月で出力");
						}
						// 「苗番号」の指定がない場合は、そのまま各月の平均糖度を算出
						else {
							// 各月の糖度平均を算出(苗番号ごとではない)
							const monthlyData = {};

							// 月毎の合計を算出
							data.forEach((item) => {
								if (item.bed_number != "平均値") {
									// YYYY-MM形式
									const month = item.date.substring(0, 7);
									const brix = parseFloat(item.brix);

									if (!monthlyData[month]) {
										monthlyData[month] = { total: 0, count: 0 };
									}

									monthlyData[month].total += brix;
									monthlyData[month].count += 1;
								}
							});
							// console.log("月毎の合計", monthlyData);

							// 月毎の平均を算出
							const result = Object.keys(monthlyData).map((month) => {
								return {
									month: month,
									averageBrix: (monthlyData[month].total / monthlyData[month].count).toFixed(1),
								};
							});
							// console.log("月毎の平均", result);

							// X軸に日付(年/月)データを代入
							this.chart.graphArrayData[this.graphIndex].options.xaxis.categories = result.map((item) => item.month);
							// Y軸に月毎の平均糖度データを代入
							this.chart.graphArrayData[this.graphIndex].series = [
								{
									name: "各月の全糖度値の平均",
									data: result.map((item) => item.averageBrix),
								},
							];

							// console.log("平均糖度(苗番号関係なし)を各月で出力");
						}
					}
					// そうでない場合は、そのまま折れ線として糖度データを日付毎に表示させる
					else {
						// 各bed_numberごとのデータを格納するオブジェクトを初期化
						const groupedData = {};

						data.forEach((item) => {
							//アイテムの中身によって、座標に代入する値を制御
							this.dataBranching(item);

							// groupedDataを更新
							if (!groupedData[item.bed_number]) {
								groupedData[item.bed_number] = { name: item.bed_number, data: [] };
							}

							// X軸とY軸に必要な値を追加
							if (this.x_value && this.y_value !== undefined) {
								// X軸のカテゴリーに日付を追加(重複を避ける)
								if (this.x_value && this.chart.graphArrayData[this.graphIndex].options.xaxis.categories.indexOf(this.x_value) === -1) {
									this.chart.graphArrayData[this.graphIndex].options.xaxis.categories.push(this.x_value);
								}

								// データを追加
								groupedData[item.bed_number].data.push({
									date: this.x_value,
									value: parseFloat(this.y_value),
								});
							}
						});

						// 各bed_numberごとのデータをchart.seriesに変換
						Object.keys(groupedData).forEach((bed_number) => {
							const seriesData = this.chart.graphArrayData[this.graphIndex].options.xaxis.categories.map((date) => {
								const dataPoint = groupedData[bed_number].data.find((d) => d.date === date);

								//データがない場合はnullを返す
								return dataPoint ? dataPoint.value : null;
							});
							this.chart.graphArrayData[this.graphIndex].series.push({
								name: groupedData[bed_number].name,
								data: seriesData,
							});
						});

						// seriesが空でない場合のみ、そのデータを表示(有効なデータ点を持つ系列だけが表示され、〇表示もデータがある場合のみ表示される)
						// データポイントの中にnullが含まれる場合、その系列を削除
						// this.chart.graphArrayData[this.graphIndex].series = this.chart.graphArrayData[this.graphIndex].series.filter((series) =>
						// 	series.data.some((value) => value !== null)
						// );
						const currentSeries = this.chart.graphArrayData?.[this.graphIndex]?.series ?? [];
						this.chart.graphArrayData[this.graphIndex].series = currentSeries.filter((series) => {
							// ① 折れ線/棒の系列オブジェクト { name, data: [...] } の場合
							if (Array.isArray(series?.data)) {
								return series.data.some((v) => v !== null && v !== undefined);
							}
							// ② 円グラフなどで series が「配列そのもの」の場合
							if (Array.isArray(series)) {
								return series.some((v) => v !== null && v !== undefined);
							}
							// ③ どれにも当てはまらない（不正形）→除外
							return false;
						});
						// console.log("各日付ごとの糖度データを折れ線グラフとして表示");
					}
				}
				// ハウス内気温、グリーンハウスモニター情報が返ってきている場合
				else {
					// 各bed_numberごとのデータを格納するオブジェクトを初期化
					const groupedData = {};

					data.forEach((item) => {
						//アイテムの中身によって、座標に代入する値を制御
						this.dataBranching(item);

						// groupedDataを更新
						if (!groupedData[item.bed_number]) {
							groupedData[item.bed_number] = { name: item.bed_number, data: [] };
						}

						// X軸とY軸に必要な値を追加
						if (this.x_value && this.y_value !== undefined) {
							// X軸のカテゴリーに日付を追加(重複を避ける)
							if (this.x_value && this.chart.graphArrayData[this.graphIndex].options.xaxis.categories.indexOf(this.x_value) === -1) {
								this.chart.graphArrayData[this.graphIndex].options.xaxis.categories.push(this.x_value);
							}

							// データを追加
							groupedData[item.bed_number].data.push({
								date: this.x_value,
								value: parseFloat(this.y_value),
							});
						}
					});

					// 各bed_numberごとのデータをchart.seriesに変換
					Object.keys(groupedData).forEach((bed_number) => {
						const seriesData = this.chart.graphArrayData[this.graphIndex].options.xaxis.categories.map((date) => {
							const dataPoint = groupedData[bed_number].data.find((d) => d.date === date);

							//データがない場合はnullを返す
							return dataPoint ? dataPoint.value : null;
						});
						this.chart.graphArrayData[this.graphIndex].series.push({
							name: groupedData[bed_number].name,
							data: seriesData,
						});
					});

					// seriesが空でない場合のみ、そのデータを表示(有効なデータ点を持つ系列だけが表示され、〇表示もデータがある場合のみ表示される)
					// データポイントの中にnullが含まれる場合、その系列を削除
					const currentSeries = this.chart.graphArrayData?.[this.graphIndex]?.series ?? [];
					this.chart.graphArrayData[this.graphIndex].series = currentSeries.filter((series) => {
						// 折れ線/棒の系列オブジェクト { name, data: [...] } の場合
						if (Array.isArray(series?.data)) {
							return series.data.some((v) => v !== null && v !== undefined);
						}
						// 円グラフなどで series が「配列そのもの」の場合
						if (Array.isArray(series)) {
							return series.some((v) => v !== null && v !== undefined);
						}
						// どれにも当てはまらない（不正形）→除外
						return false;
					});
					// console.log("ハウス内気温、グリーンハウスモニター情報のグラフを描画");
				}

				// console.log("折れ線グラフを出力");
			}
			// バックエンドから返ってきたグラフ種別が「縦棒グラフ」の場合
			else if (graphType == "bar") {
				// 糖度データ問い合わせ確認(bed番号が返ってきている場合でも一緒に判断)
				// dataがnullではなく、配列である、かつ「date」「brix」「bed_number」が両方ともundefinedではない場合にtrueを返して縦棒グラフを生成する
				const hasBrixData =
					Array.isArray(data) && data.some((item) => item.date !== undefined && item.brix !== undefined && item.bed_number !== undefined);
				// console.log("hasBrixData", hasBrixData);

				// 収穫量データ問い合わせ確認
				// dataがnullではなく、配列である、かつ「date」「crop_yeild」が両方ともundefinedではない場合にtrueを返して縦棒グラフを生成する
				const hasHarvestData = Array.isArray(data) && data.some((item) => item.date !== undefined && item.crop_yeild !== undefined);
				// console.log("hasHarvestData", hasHarvestData);

				// グリーンハウスモニター情報問い合わせ確認
				// dataがnullではなく、配列である、かつ「date」「date_time」「outeside_temprerature」などのプロパティが両方ともundefinedではない場合にtrueを返して縦棒グラフを生成する
				const hasGreenHouseData =
					Array.isArray(data) &&
					data.some(
						(item) =>
							item.date !== undefined &&
							(item.outside_temperature !== undefined ||
								item.inside_temperature !== undefined ||
								item.target_temperature !== undefined ||
								item.inside_relative_humidity !== undefined ||
								item.outside_relative_humidity !== undefined ||
								item.solar_radiation_intensity !== undefined ||
								item.co2_concentration !== undefined ||
								item.photosynthesis_rate !== undefined)
					);
				// console.log("hasGreenHouseData", hasGreenHouseData);

				// 総収量データ情報問い合わせ確認
				// dataがnullではなく、配列である、かつ「date」「weight」のプロパティが両方ともundefinedではない場合にtrueを返して縦棒グラフを生成する
				const hasGrossHarvestData = Array.isArray(data) && data.some((item) => item.date !== undefined && item.weight !== undefined);
				// console.log("hasGrossHarvestData", hasGrossHarvestData);

				// 糖度データ一式が返ってきている場合
				// データの平均値を出して、縦棒グラフにする
				if (hasBrixData) {
					// console.log("糖度データの準備開始");

					// ユーザープロンプトの中に、"ベッド", "ベッド番号", "bed", "bed番号", "Bed", "Bed番号", "苗番号", "調査株", "#"の
					// いずれかの単語が入っている場合：各苗番号ごとの平均値を年で計算、グラフに出力
					// そうでない場合：各年の全計測値を平均、グラフに出力
					if (this.judgePromptWord(userPrompt)) {
						// ユーザープロンプト中に「今作」のキーワードが入っている場合には今作のデータを算出
						if (this.judgePromptNowMadeWord(userPrompt)) {
							// グループ化するための変数を用意
							const groupedData = {};

							// 今作(2024/8/22～2025/1/15)データの処理
							const newDataPeriodStart = new Date(this.period_of_seedlings_made_start);
							const newDataPeriodEnd = new Date(this.period_of_seedlings_made_final);
							// console.log("指定した今作の期間", newDataPeriodStart + "～" + newDataPeriodEnd);

							// 今作の期間に含まれる年をセットに追加
							const excludedYears = new Set();
							// 2024年
							excludedYears.add(newDataPeriodStart.getFullYear().toString());
							// 2025年
							excludedYears.add(newDataPeriodEnd.getFullYear().toString());
							// console.log("除外する期間の年", excludedYears);

							// 除外する年以外のデータの合計を苗番号ごとに算出
							data.forEach((item) => {
								// 年を取得
								const year = new Date(item.date).getFullYear();
								// console.log("year", year);

								// 苗番号を取得
								const bedNumber = item.bed_number;
								// console.log("bedNumber", bedNumber);

								// 糖度を取得
								const brixValue = parseFloat(item.brix);
								// console.log("brixValue", brixValue);

								// "平均値"をスキップ
								// ※平均値の値は一部の日付で格納されているが、こちら側で全集計を行うためこの値は取得しない
								if (bedNumber === "平均値") {
									// 何もせずに次のループへ
									return;
								}

								// 年が除外年のセットに含まれている場合はスキップ
								if (excludedYears.has(year.toString())) {
									// console.log(`${year.toString()}年のデータは計算しません`);

									// 除外対象の年のデータは計算しない
									return;
								}

								// 年とbed_numberの組み合わせでグループ化
								if (!groupedData[year]) {
									groupedData[year] = {};
								}
								if (!groupedData[year][bedNumber]) {
									groupedData[year][bedNumber] = { total: 0, count: 0 };
								}

								groupedData[year][bedNumber].total += brixValue;
								groupedData[year][bedNumber].count += 1;
							});
							// console.log("groupedData", groupedData);

							// グラフ出力用の変数を用意
							const chartData = { years: [], series: [] };

							// 既存のデータを追加
							Object.keys(groupedData).forEach((year) => {
								const bedNumbers = Object.keys(groupedData[year]);

								bedNumbers.forEach((bedNumber) => {
									const avgBrix = groupedData[year][bedNumber].total / groupedData[year][bedNumber].count;

									const seriesIndex = chartData.series.findIndex((series) => series.name === bedNumber);
									if (seriesIndex === -1) {
										chartData.series.push({ name: bedNumber, data: new Array(Object.keys(groupedData).length).fill(0) });
									}

									const bedSeries = chartData.series.find((series) => series.name === bedNumber);
									bedSeries.data[chartData.years.length] = parseFloat(avgBrix.toFixed(1));
								});

								// 年データを追加
								chartData.years.push(year);
							});
							// console.log("除外された年以外の平均", groupedData);
							// console.log("除外する年以外の横軸ラベル", chartData.years);

							// 今作のデータのフィルタリング
							const nowData = data.filter((item) => {
								const date = new Date(item.date);
								return date >= newDataPeriodStart && date <= newDataPeriodEnd;
							});
							// console.log("nowData", nowData);

							// 今作のデータの平均計算
							if (nowData.length > 0) {
								const nowBrixCollection = {};

								// 今作のデータを集計する処理
								nowData.forEach((item) => {
									const bedNumber = item.bed_number;
									const brixValue = parseFloat(item.brix);

									if (!nowBrixCollection[bedNumber]) {
										nowBrixCollection[bedNumber] = { total: 0, count: 0 };
									}

									// 現在の苗番号のデータを集計
									nowBrixCollection[bedNumber].total += brixValue;
									nowBrixCollection[bedNumber].count += 1;
								});

								// 今作のデータをチャートに追加
								Object.keys(nowBrixCollection).forEach((bedNumber) => {
									const avgBrix = nowBrixCollection[bedNumber].total / nowBrixCollection[bedNumber].count;

									const seriesIndex = chartData.series.findIndex((series) => series.name === bedNumber);
									if (seriesIndex === -1) {
										// 苗番号シリーズを追加
										chartData.series.push({ name: bedNumber, data: new Array(chartData.years.length).fill(0) });
									}

									const nowSeries = chartData.series.find((series) => series.name === bedNumber);
									// 今作のデータを追加
									nowSeries.data.push(parseFloat(avgBrix.toFixed(1)));
								});

								// 今作のラベルを追加
								chartData.years.push("今作");
							}
							// console.log("今作データ平均計算後の横軸データ", chartData.years);
							// console.log("今作データ平均計算後の縦軸データ", chartData.series);

							// X軸に年データを代入
							this.chart.graphArrayData[this.graphIndex].options.xaxis.categories = chartData.years;
							// Y軸に平均値のデータを代入
							this.chart.graphArrayData[this.graphIndex].series = chartData.series;

							// console.log("今作のデータを苗番号毎にグラフに反映");
						}
						// 「今作」のワードが入っていない場合には、そのまま指定された期間でグラフを描画
						else {
							// グループ化するための変数を用意
							const groupedData = {};

							data.forEach((item) => {
								// 年を取得
								const year = new Date(item.date).getFullYear();
								// console.log("year", year);

								// 苗番号を取得
								const bedNumber = item.bed_number;
								// console.log("bedNumber", bedNumber);

								// 糖度を取得
								const brixValue = parseFloat(item.brix);
								// console.log("brixValue", brixValue);

								// "平均値"をスキップ
								// ※平均値の値は一部の日付で格納されているが、こちら側で全集計を行うためこの値は取得しない
								if (bedNumber === "平均値") {
									// 何もせずに次のループへ
									return;
								}

								// 年とbed_numberの組み合わせでグループ化
								if (!groupedData[year]) {
									groupedData[year] = {};
								}
								if (!groupedData[year][bedNumber]) {
									groupedData[year][bedNumber] = { total: 0, count: 0 };
								}

								groupedData[year][bedNumber].total += brixValue;
								groupedData[year][bedNumber].count += 1;
							});
							// console.log("groupedData", groupedData);

							// グラフ出力用の変数を用意
							const chartData = { years: [], series: [] };

							// 平均値を計算し、チャート用のデータ形式に整形
							Object.keys(groupedData).forEach((year) => {
								// chartData.years.push(year);
								const yearData = [];
								const bedNumbers = Object.keys(groupedData[year]);

								// 各bed番号ごとに計算
								bedNumbers.forEach((bedNumber) => {
									// 各bed番号ごとの平均値を計算
									const avgBrix = groupedData[year][bedNumber].total / groupedData[year][bedNumber].count;
									// 計算された平均値を、小数点第1位までに変換
									yearData.push(parseFloat(avgBrix.toFixed(1)));

									// 年リストに存在しない場合は初期化
									const seriesIndex = chartData.series.findIndex((series) => series.name === bedNumber);
									if (seriesIndex === -1) {
										chartData.series.push({ name: bedNumber, data: new Array(Object.keys(groupedData).length).fill(0) });
									}
									// データを年に合わせて更新
									const bedSeries = chartData.series.find((series) => series.name === bedNumber);
									// 平均値を小数第1位までに変換して、現年に挿入
									bedSeries.data[chartData.years.length] = parseFloat(avgBrix.toFixed(1));
								});

								chartData.years.push(year);
							});
							// console.log("chartData", chartData);

							// X軸に年データを代入
							this.chart.graphArrayData[this.graphIndex].options.xaxis.categories = chartData.years;
							// Y軸に平均値のデータを代入
							this.chart.graphArrayData[this.graphIndex].series = chartData.series;

							// console.log("そのまま各Bed番号ごとの平均値をグラフとして出力");
						}
					}
					// ユーザープロンプトの中に指定したキーワードが入っていない場合において、「今作」のキーワードが入っていた場合には今作データも算出してグラフに反映
					// そうでない場合には、そのまま各年ごとの糖度データの平均を算出・縦棒グラフに反映
					// ※「date」「bed_number」「brix」が1セットで必ず返ってきている想定
					else {
						// ユーザープロンプト中に「今作」のワードが入っている場合には、今作の平均データを算出、グラフに反映
						if (this.judgePromptNowMadeWord(userPrompt)) {
							// 今作(2024/8/22～2025/1/15)データの処理
							const newDataPeriodStart = new Date(this.period_of_seedlings_made_start);
							const newDataPeriodEnd = new Date(this.period_of_seedlings_made_final);
							// console.log("指定した今作の期間", newDataPeriodStart + "～" + newDataPeriodEnd);

							// 今作の期間に含まれる年をセットに追加
							const excludedYears = new Set();
							// 2024年
							excludedYears.add(newDataPeriodStart.getFullYear().toString());
							// 2025年
							excludedYears.add(newDataPeriodEnd.getFullYear().toString());
							// console.log("除外する期間の年", excludedYears);

							// 年ごとのbrixデータを集計
							const yearlyBrix = data.reduce((acc, entry) => {
								// "bad_number"が"平均値"でない場合のみ処理を続行
								if (entry.bed_number != "平均値") {
									const year = entry.date.split("-")[0];
									const brixValue = parseFloat(entry.brix);
									// const entryDate = new Date(entry.date);

									// 年が除外年のセットに含まれている場合はスキップ
									if (excludedYears.has(year)) {
										// console.log(`${year}年のデータは計算しません`);

										// 除外対象の年のデータは計算しない
										return acc;
									}

									// 年の累計
									if (!acc[year]) {
										acc[year] = { total: 0, count: 0 };
									}
									acc[year].total += brixValue;
									acc[year].count += 1;
								}
								return acc;
							}, {});

							// 平均を計算
							const averages = Object.keys(yearlyBrix).map((year) => ({
								year,
								average: (yearlyBrix[year].total / yearlyBrix[year].count).toFixed(1),
							}));

							// 「2024/8/22～2025/1/15」データの処理
							const newData = data.filter((entry) => {
								const date = new Date(entry.date);
								return date >= newDataPeriodStart && date <= newDataPeriodEnd;
							});

							// 新作データの平均を計算
							let newTotal = 0;
							let newCount = 0;

							newData.forEach((entry) => {
								if (entry.bed_number != "平均値") {
									newTotal += parseFloat(entry.brix);
									newCount++;
								}
							});

							// 新作の平均値を計算（存在する場合のみ）
							const newAverage = newCount > 0 ? (newTotal / newCount).toFixed(1) : 0;

							// X軸データを年データと新作を追加
							const xCategories = [...averages.map((data) => data.year), "今作"];
							this.chart.graphArrayData[this.graphIndex].options.xaxis.categories = xCategories;

							// Y軸に計算後の各年の計測値の平均データを代入
							const yData = [...averages.map((data) => data.average), newAverage];
							this.chart.graphArrayData[this.graphIndex].series = [
								{
									name: "各年の全糖度値の平均",
									data: yData,
								},
							];

							// console.log("今作のデータを算出、グラフに出力");
						}
						// ユーザープロンプト中に「今作」のワードが入っていない場合には、そのままグラフを表示
						else {
							// 年ごとのbrixデータを集計
							const yearlyBrix = data.reduce((acc, entry) => {
								// "bad_number"が"平均値"でない場合のみ処理を続行
								// ※"平均値"の値は、計算に含めない
								if (entry.bed_number != "平均値") {
									const year = entry.date.split("-")[0];
									const brixValue = parseFloat(entry.brix);
									if (!acc[year]) {
										acc[year] = { total: 0, count: 0 };
									}
									acc[year].total += brixValue;
									acc[year].count += 1;
								}
								return acc;
							}, {});
							// console.log("年毎のbrixデータの合計", yearlyBrix);

							// 平均を計算
							const averages = Object.keys(yearlyBrix).map((year) => ({
								year,
								average: (yearlyBrix[year].total / yearlyBrix[year].count).toFixed(1),
							}));
							// console.log("brixデータの各年の平均", averages);

							// X軸に年データを代入
							this.chart.graphArrayData[this.graphIndex].options.xaxis.categories = averages.map((data) => data.year);

							// Y軸に計算後の各年の計測値の平均データを代入
							this.chart.graphArrayData[this.graphIndex].series = [
								{
									name: "各年の全糖度値の平均",
									data: averages.map((data) => data.average),
								},
							];

							// console.log("各年の全平均値をグラフとして出力");
						}
					}

					// console.log("糖度の過去データの平均値を縦棒グラフとして出力");
				}
				// 収穫量データが返って来ている場合
				// それぞれの収穫量を年毎にグラフに表示
				else if (hasHarvestData) {
					const chartData = { dates: [], series: [{ name: "収穫量", data: [] }] };

					data.forEach((item) => {
						// 収穫量データが存在するデータのみ、配列に格納
						if (item.crop_yeild != null) {
							// 日付を取得
							const date = item.date;
							// X軸に格納する日付を格納
							chartData.dates.push(date);

							// 収穫量を取得
							const crop_yeild = parseFloat(item.crop_yeild).toFixed(2);
							// Y軸に格納する収穫量データを格納
							chartData.series[0].data.push(crop_yeild);
						}
					});

					// X軸に日付データを代入
					this.chart.graphArrayData[this.graphIndex].options.xaxis.categories = chartData.dates;
					// Y軸に収穫量のデータを代入
					this.chart.graphArrayData[this.graphIndex].series = chartData.series;

					// console.log("各年の収穫量データを縦棒グラフとして出力");
				}
				// グリーンハウスモニター情報が返ってきている場合
				// 返ってきた日付をカウントして、各年数ごとにグラフを表示する
				else if (hasGreenHouseData) {
					const uniqueDates = {};

					// ユニークな日付をカウントする
					data.forEach((item) => {
						const date = new Date(item.date);
						const year = date.getFullYear();
						// YYYY-MM-DD
						const day = date.toISOString().split("T")[0];

						if (!uniqueDates[year]) {
							uniqueDates[year] = new Set();
							// console.log("年が変わりました");
						}
						uniqueDates[year].add(day);
					});

					// 年ごとの日数を計算
					const chartData = Object.keys(uniqueDates).map((year) => ({
						year: year,
						daysCount: uniqueDates[year].size,
					}));

					// X軸に日付データを代入
					this.chart.graphArrayData[this.graphIndex].options.xaxis.categories = chartData.map((data) => data.year);

					// Y軸に収穫量のデータを代入
					this.chart.graphArrayData[this.graphIndex].series = [
						{
							name: "日数",
							data: chartData.map((data) => data.daysCount),
						},
					];

					// console.log("各年の日付の日数を縦棒グラフとして出力");
				}
				// 総収量データ情報が返ってきている場合
				// 各年ごとの総収量を計算、グラフに出力
				else if (hasGrossHarvestData) {
					// 年ごとのweightの合計を算出
					const result = data.reduce((acc, item) => {
						const year = new Date(item.date).getFullYear();
						const weight = parseFloat(item.weight);

						if (!acc[year]) {
							acc[year] = 0;
						}

						acc[year] += weight;
						return acc;
					}, {});

					// 小数第2位までに制限
					const formattedResult = Object.keys(result).reduce((acc, year) => {
						// toFixedで小数第2位までを取得し、parseFloatで数値に戻す
						acc[year] = parseFloat(result[year].toFixed(2));
						return acc;
					}, {});

					// オブジェクトを配列形式に整形
					const chartData = Object.keys(result).map((year) => ({
						year: year,
						totalWeight: formattedResult[year],
					}));

					// X軸に日付データを代入
					this.chart.graphArrayData[this.graphIndex].options.xaxis.categories = chartData.map((item) => item.year);
					// Y軸に収穫量のデータを代入
					this.chart.graphArrayData[this.graphIndex].series = [
						{
							name: "総収量合計",
							data: chartData.map((item) => item.totalWeight),
						},
					];

					// console.log("各年の総収量データの合計を縦棒グラフとして出力");
				}

				// console.log("縦棒グラフを出力");
			}
			// 円グラフ2つパターンからグラフ種別ボタンで縦棒グラフに切り替えた場合
			else if (graphType == "pietobar") {
				// console.log("preparedChartにてサイズごとの縦棒グラフを描画");

				// 総収量データ情報問い合わせ確認
				// dataがnullではなく、配列である、かつ「date」「class」「weight」のプロパティが両方ともundefinedではない場合にtrueを返して縦棒グラフを生成する
				const hasGrossHarvestData =
					Array.isArray(data) && data.some((item) => item.date !== undefined && item.class !== undefined && item.weight !== undefined);

				// 総収量データが返ってきている場合のみ実行
				if (hasGrossHarvestData) {
					// 日付をキーとしたクラスごとのweightを集計する
					const aggregatedData = {};

					// 各クラスごとに重量を計算
					data.forEach((entry) => {
						const className = entry.class;

						// クラスが「2S_3L以上合計」の場合は総収量の計算に含めない
						if (className == "2S_3L以上合計") {
							return;
						}
						// NaNの時は0にする
						const weight = parseFloat(entry.weight) || 0;
						// YYYY-MM形式のキーを作成
						const dateKey = entry.date.split("-").slice(0, 2).join("-");

						if (!aggregatedData[dateKey]) {
							aggregatedData[dateKey] = {};
						}
						if (!aggregatedData[dateKey][className]) {
							aggregatedData[dateKey][className] = 0;
						}
						aggregatedData[dateKey][className] += weight;
					});
					// console.log("各クラスごとのデータ", aggregatedData);

					// グラフのシリーズとカテゴリを準備

					// 決められた順番でラベルを配置
					this.chart.graphArrayData[this.graphIndex].options.xaxis.categories = this.classBarOrder;

					// 日付のカテゴリを配列で保持
					const dateKeys = Object.keys(aggregatedData);
					// console.log("dateKeys", dateKeys);

					this.chart.graphArrayData[this.graphIndex].series = dateKeys.map((dateKey) => ({
						name: dateKey,
						// 各クラスのweightを小数第2位まで出力
						// classBarOrderの順番でデータも並び替える
						data: this.classBarOrder.map((className) => {
							const weight = aggregatedData[dateKey][className] || 0;
							// 小数第2位まで算出
							return parseFloat(weight.toFixed(2));
						}),
					}));
					// --- シリーズ（年月）ごとの色設定 & distributed を OFF ---
					const slot = this.chart.graphArrayData[this.graphIndex];

					// distributed=false（ポイントごとの色配布を無効化）
					slot.options.plotOptions = slot.options.plotOptions || {};
					slot.options.plotOptions.bar = { ...(slot.options.plotOptions.bar || {}), distributed: false };

					// 凡例のマーカーもシリーズ色に合わせる
					slot.options.legend = slot.options.legend || {};
				}
			}
			// バックエンドから返ってきたグラフ種別が「円グラフ(1つのみ出力パターン)」の場合
			else if (graphType == "pie") {
				// 1) 総収量データの存在チェック
				// dataがnullではなく、配列である、かつ「date」「class」「weight」のプロパティが両方ともundefinedではない場合にtrueを返して円グラフを生成する
				const hasGrossHarvestData = Array.isArray(data) && data.some((item) => item.date !== undefined && item.class !== undefined);
				// console.log("hasGrossHarvestData", hasGrossHarvestData);

				// 総収量データが返ってきている場合
				if (hasGrossHarvestData) {
					// 2) クラス別に重み（weight）を安全に集計
					const classWeights = {};

					(Array.isArray(data) ? data : []).forEach((item) => {
						if (item.class == "2S_3L以上合計") {
							// 「2S_3L以上合計」の場合、weightが空の場合、次のデータを取得
							if (item.weight === "") {
								return;
							}
						}
						const w = Number(item.weight);
						const weight = Number.isFinite(w) ? w : 0;
						const key = item?.class;
						if (!key) return;
						if (!classWeights[key]) classWeights[key] = 0;
						classWeights[key] += weight;
					});
					// console.log("classWeights", classWeights);
					// console.log("totalWeight", totalWeight);

					// 3) 並びと色を classPieOrder に合わせる
					const labels = Object.keys(classWeights);
					const ordered = this.classPieOrder.reduce(
						(acc, label) => {
							const idx = labels.indexOf(label);
							if (idx !== -1) {
								acc.labels.push(label);
								acc.weights.push(classWeights[label]);
								acc.colors.push(this.colorPalette[label] ?? "#999999");
							}
							return acc;
						},
						{ labels: [], weights: [], colors: [] }
					);

					// 合計 0 なら描画しない（空円フォールバックを避ける）
					const sum = ordered.weights.reduce((s, w) => s + (Number.isFinite(Number(w)) ? Number(w) : 0), 0);
					if (sum <= 0 || ordered.labels.length === 0) return;

					// 4) ラベル用の「合計100%になる補正済み％」（最大剰余法）
					const rawPercents = ordered.weights.map((w) => (w / sum) * 100);
					const floored = rawPercents.map((p) => Math.floor(p));
					let diff = 100 - floored.reduce((s, p) => s + p, 0);
					const fracOrder = rawPercents.map((p, i) => ({ i, frac: p - Math.floor(p) })).sort((a, b) => b.frac - a.frac);
					for (let k = 0; k < diff; k++) {
						const idx = fracOrder[k % fracOrder.length].i;
						floored[idx] += 1;
					}
					const correctedPercents = floored; // 合計は必ず 100

					// 5) 円グラフのオブジェクトを 更新（series は重み / tooltip は kg）
					// 既存スロットを取得
					const slot = this.chart.graphArrayData[this.graphIndex];

					// オプションを上書き（必要なキーのみ確実にセット）
					slot.options.chart = { type: "pie", toolbar: { show: false } };
					slot.options.colors = ordered.colors;
					slot.options.tooltip = {
						enabled: true,
						theme: "dark",
						y: {
							formatter: (val /* , opts */) => {
								const kgNum = Number(val);
								const kg = (Number.isFinite(kgNum) ? kgNum : 0).toFixed(2);
								const pct = sum > 0 ? (kgNum / sum) * 100 : 0;
								// ラベルと同じ丸め（整数）。小数1桁にしたい場合は toFixed(1) に変更
								const pctStr = `${Math.round(pct)}%`;
								return `${kg} kg (${pctStr})`;
							},
						},
					};

					// ラベルと補正済み％（dataLabels フォーマッタから参照）
					slot.options.labels = ordered.labels;
					slot.options.customPercents = correctedPercents;

					// series は数値配列
					slot.series = ordered.weights;
				}

				// console.log("円グラフを出力");
			}
			// バックエンドから返ってきたグラフ種別が「円グラフ(2つのみ出力パターン)」の場合
			else {
				// console.log("円グラフを2つ出力パターンでデータを成形");

				// 総収量データ情報問い合わせ確認
				// dataがnullではなく、配列である、かつ「date」「class」「weight」のプロパティが両方ともundefinedではない場合にtrueを返して円グラフを生成する
				const hasGrossHarvestData = Array.isArray(data) && data.some((item) => item.date !== undefined && item.class !== undefined);
				// console.log("hasGrossHarvestData", hasGrossHarvestData);

				if (hasGrossHarvestData) {
					// console.log("総収量データから2つの円グラフを描画させるように座標を成形");

					// 各年・月ごとの割合を計算
					const monthlyData = this.prepareYearMonthlyDataWithRatios(data);
					// console.log("計算されたmonthlyData", monthlyData);
					const months = Object.keys(monthlyData).sort(); // 表示順を保証（必要なら .sort() を外して元順）

					months.forEach((sortKey) => {
						const { labels, weights, displayKey } = monthlyData[sortKey];

						// classPieOrder に従い、labels と weights と colors を同一順に並べる
						const ordered = this.classPieOrder.reduce(
							(acc, label) => {
								const idx = labels.indexOf(label);
								if (idx !== -1) {
									acc.labels.push(label);
									acc.weights.push(weights[idx]);
									acc.colors.push(this.colorPalette[label] ?? "#999999");
								}
								return acc;
							},
							{ labels: [], weights: [], colors: [] }
						);

						// 合計が 0 の月は描画しない（空円フォールバックを避ける）
						const sum = ordered.weights.reduce((s, w) => s + (Number.isFinite(Number(w)) ? Number(w) : 0), 0);
						if (sum <= 0 || ordered.labels.length === 0) return;

						// 補正前の連続値（小数％）
						const rawPercents = ordered.weights.map((w) => (w / sum) * 100);
						// 小数部を保持しつつ整数化（floor）して合計差分を配る：最大剰余法
						const floored = rawPercents.map((p) => Math.floor(p));
						let diff = 100 - floored.reduce((s, p) => s + p, 0);
						// 小数部が大きい順に +1 を配る
						const fracOrder = rawPercents.map((p, i) => ({ i, frac: p - Math.floor(p) })).sort((a, b) => b.frac - a.frac);
						for (let k = 0; k < diff; k++) {
							const idx = fracOrder[k % fracOrder.length].i;
							floored[idx] += 1;
						}
						// 補正済みの整数％（合計100）を config に載せて formatter から参照
						const correctedPercents = floored; // 合計は必ず 100

						this.chart.graphArrayData.push({
							dayName: displayKey,
							options: {
								chart: { type: "pie", toolbar: { show: false } },
								colors: ordered.colors,
								xaxis: { categories: [] },
								markers: { size: 1 },
								tooltip: {
									enabled: true,
									theme: "dark",
									y: {
										formatter: (val /* , opts */) => {
											const kgNum = Number(val);
											const kg = (Number.isFinite(kgNum) ? kgNum : 0).toFixed(2);
											const pct = sum > 0 ? (kgNum / sum) * 100 : 0;
											const pctStr = `${Math.round(pct)}%`;
											return `${kg} kg (${pctStr})`;
										},
									},
								},

								customPercents: correctedPercents,
								dataLabels: {
									enabled: true,
									formatter: (val, opts) => {
										const idx = opts.seriesIndex ?? 0;
										const arr = opts?.w?.config?.customPercents ?? [];
										const pct = arr[idx] ?? 0;
										return `${pct}%`;
									},
								},
								labels: ordered.labels,
							},
							series: ordered.weights, // ← ％ではなく重み
						});
					});

					// 追加範囲の記録（既存ロジックに合わせて）
					const endIndex = this.chart.graphArrayData.length - 1;
					const startIndex = Math.max(0, endIndex - months.length + 1);
					this.lastPieChartRange = { start: startIndex, end: endIndex };
					this.graphIndex = endIndex;
				}
			}
			// console.log("最終的なgraphArraydata", this.chart.graphArrayData);
		},

		// 年 or 月ごとの総収量（class別）を集計して返す
		prepareYearMonthlyDataWithRatios(data) {
			const aggregated = Object.create(null);

			(Array.isArray(data) ? data : []).forEach((item) => {
				// クラス未定義や合計行はスキップ
				const className = item?.class;
				if (!className || className === "2S_3L以上合計") return;

				// 日付が不正ならスキップ
				const d = new Date(item?.date);
				if (isNaN(d)) return;

				const year = d.getFullYear();
				const month = d.getMonth() + 1;

				// 並び替え用キー（ゼロ埋め）と表示用キー（非ゼロ埋め）
				const sortKey = `${year}-${String(month).padStart(2, "0")}`;
				const displayKey = `${year}-${month}`;

				// 入れ物の初期化（必ず classes を持つ）
				if (!aggregated[sortKey]) {
					aggregated[sortKey] = { displayKey, classes: Object.create(null) };
				}

				// 重み（weight）を安全に加算
				const w = Number(item?.weight);
				const weight = Number.isFinite(w) ? w : 0;
				aggregated[sortKey].classes[className] = (aggregated[sortKey].classes[className] ?? 0) + weight;
			});

			// 出力整形：labels / weights / total を用意
			const monthlyData = Object.create(null);
			for (const sortKey in aggregated) {
				const { displayKey, classes } = aggregated[sortKey];
				const labels = Object.keys(classes);
				const weights = labels.map((l) => classes[l]);
				const total = weights.reduce((s, w) => s + w, 0);

				monthlyData[sortKey] = { labels, weights, total, displayKey };
			}
			return monthlyData;
		},

		// ユーザープロンプトの中身チェック(折れ線グラフ・縦棒グラフ、糖度データ用)
		// プロンプトの中に該当するワードが入っている場合にはtrueを返す
		judgePromptWord(userPrompt) {
			// console.log("userPrompt", userPrompt);

			const keywords = ["ベッド", "ベッド番号", "bed", "bed番号", "Bed", "Bed番号", "苗番号", "調査株", "#"];
			const containsKeywords = keywords.some((keyword) => userPrompt.includes(keyword));
			// console.log("糖度データユーザープロンプトをチェックします");
			// console.log("結果", containsKeywords);

			return containsKeywords;
		},
		// ユーザープロンプトの中身チェック(折れ線グラフ、糖度データ用)
		// プロンプトの中に該当するワードが入っている場合にはtrueを返す
		judgePromptAverageWord(userPrompt) {
			// console.log("userPrompt", userPrompt);

			const keywords = ["平均"];
			const containsKeywords = keywords.some((keyword) => userPrompt.includes(keyword));
			// console.log("ユーザープロンプトをチェックします");
			// console.log("結果", containsKeywords);

			return containsKeywords;
		},
		// ユーザープロンプトの中身チェック(縦棒グラフ、糖度データ用)
		judgePromptNowMadeWord(userPrompt) {
			// console.log("userPrompt", userPrompt);

			const keywords = ["今作"];
			const containsKeywords = keywords.some((keyword) => userPrompt.includes(keyword));
			// console.log("ユーザープロンプトをチェックします");
			// console.log("結果", containsKeywords);

			return containsKeywords;
		},
		// 折れ線グラフの種別判断で、かつ収穫量データが返ってきたときのデータ分岐判断
		dataHarvestBranching(item) {
			// 収穫量データ(crop_harvest)が返ってきている場合は、収穫量データを各座標に代入
			if (item.crop_yeild != null) {
				// X軸に日付情報を代入
				this.x_value = item.date;
				// Y軸に収穫量情報を代入
				this.y_value = item.crop_yeild;
				// console.log("収穫量のグラフを生成します");
			} else {
				// console.log("データがないため、次のデータを取得します");
				return;
			}
		},
		// 座標に代入するデータの分岐判断
		dataBranching(item) {
			// 糖度データ(brix_state)が返ってきている場合は、糖度データを各座標に代入
			if (item.brix != null) {
				// X軸に日付情報を代入
				this.x_value = item.date;
				// Y軸に糖度情報を代入
				this.y_value = item.brix;

				// console.log("糖度のグラフを生成します");
			}
			// ハウス内気温情報(greenhouse_daily_temperature)が返ってきている場合は、それぞれ返ってきたパラメーターの情報を代入
			// 1.「平均気温」の情報が返ってきている場合(仮、クエリは必要な情報以外取ってこない想定)
			else if (item.average_temperature != null) {
				// X軸に日付情報を代入
				this.x_value = item.date;
				// Y軸に「平均気温」情報を代入
				this.y_value = item.average_temperature;

				// console.log("平均気温のグラフを生成します");
			}
			// 2.「昼平均気温」の情報が返ってきている場合(仮、クエリは必要な情報以外取ってこない想定)
			else if (item.average_daytime_temperature != null) {
				// X軸に日付情報を代入
				this.x_value = item.date;
				// Y軸に「昼平均気温」情報を代入
				this.y_value = item.average_daytime_temperature;

				// console.log("昼平均気温のグラフを生成します");
			}
			// 3.「夜平均気温」の情報が返ってきている場合(仮、クエリは必要な情報以外取ってこない想定)
			else if (item.average_nighttime_temperature != null) {
				// X軸に日付情報を代入
				this.x_value = item.date;
				// Y軸に「夜平均気温」情報を代入
				this.y_value = item.average_nighttime_temperature;

				// console.log("夜平均気温のグラフを生成します");
			}
			// 4.「最高気温」の情報が返ってきている場合(仮、クエリは必要な情報以外取ってこない想定)
			else if (item.max_temperature != null) {
				// X軸に日付情報を代入
				this.x_value = item.date;
				// Y軸に「最高気温」情報を代入
				this.y_value = item.max_temperature;

				// console.log("最高気温のグラフを生成します");
			}
			// 5.「最低気温」の情報が返ってきている場合(仮、クエリは必要な情報以外取ってこない想定)
			else if (item.min_temperature != null) {
				// X軸に日付情報を代入
				this.x_value = item.date;
				// Y軸に「最低気温」情報を代入
				this.y_value = item.min_temperature;

				// console.log("最低気温のグラフを生成します");
			}
			// グリーンハウスモニター情報(greenhouse_info)が返ってきている場合は、それぞれ返ってきたパラメーターの情報を代入
			// 1.「ハウス内温度」の情報が返ってきている場合(仮、クエリは必要な情報以外取ってこない想定)
			else if (item.inside_temperature != null) {
				// X軸に日時情報を代入
				this.x_value = item.date;
				// Y軸に「ハウス内温度」情報を代入
				this.y_value = item.inside_temperature.toFixed(1);

				// console.log("ハウス内温度のグラフを生成します");
			}
			// 2.「室外温度」の情報が返ってきている場合(仮、クエリは必要な情報以外取ってこない想定)
			else if (item.outside_temperature != null) {
				// X軸に日時情報を代入
				this.x_value = item.date;
				// Y軸に「室外温度」情報を代入
				this.y_value = item.outside_temperature.toFixed(1);

				// console.log("室外温度のグラフを生成します");
			}
			// 3.「目標温度」の情報が返ってきている場合(仮、クエリは必要な情報以外取ってこない想定)
			else if (item.target_temperature != null) {
				// X軸に日時情報を代入
				this.x_value = item.date;
				// Y軸に「目標温度」情報を代入
				this.y_value = item.target_temperature;

				// console.log("目標温度のグラフを生成します");
			}
			// 4.「ハウス内相対湿度」の情報が返ってきている場合(仮、クエリは必要な情報以外取ってこない想定)
			else if (item.inside_relative_humidity != null) {
				// X軸に日時情報を代入
				this.x_value = item.date;
				// Y軸に「ハウス内相対湿度」情報を代入
				this.y_value = item.inside_relative_humidity;

				// console.log("ハウス内相対湿度のグラフを生成します");
			}
			// 5.「室外相対湿度」の情報が返ってきている場合(仮、クエリは必要な情報以外取ってこない想定)
			else if (item.outside_relative_humidity != null) {
				// X軸に日時情報を代入
				this.x_value = item.date;
				// Y軸に「室外相対湿度」情報を代入
				this.y_value = item.outside_relative_humidity;

				// console.log("室外相対湿度のグラフを生成します");
			}
			// 6.「屋外日射」の情報が返ってきている場合(仮、クエリは必要な情報以外取ってこない想定)
			else if (item.solar_radiation_intensity != null) {
				// X軸に日時情報を代入
				this.x_value = item.date;
				// Y軸に「屋外日射」情報を代入
				this.y_value = item.solar_radiation_intensity;

				// console.log("屋外日射のグラフを生成します");
			}
			// 7.「CO2濃度」の情報が返ってきている場合(仮、クエリは必要な情報以外取ってこない想定)
			else if (item.co2_concentration != null) {
				// X軸に日時情報を代入
				this.x_value = item.date;
				// Y軸に「CO2濃度」情報を代入
				this.y_value = item.co2_concentration;

				// console.log("CO2濃度のグラフを生成します");
			}
			// 8.「光合成速度」の情報が返ってきている場合(仮、クエリは必要な情報以外取ってこない想定)
			else if (item.photosynthesis_rate != null) {
				// X軸に日時情報を代入
				this.x_value = item.date;
				// Y軸に「光合成速度」情報を代入
				this.y_value = item.photosynthesis_rate;

				// console.log("光合成速度のグラフを生成します");
			}
			// 総収量情報(gross_harvest)が返ってきている場合は、返ってきたパラメーターの情報を代入
			else if (item.weight != null) {
				// X軸に日付情報を代入
				this.x_value = item.date;
				// Y軸に「重量」情報を代入
				this.y_value = item.weight;

				// console.log("重量のグラフを生成します");
			}
			// 計測データ情報(growth_data)が返ってきている場合は、返ってきたパラメーターの情報を代入
			// 1. 「SPAD値」の情報が返ってきている場合(仮、クエリは必要な情報以外取ってこない想定)
			else if (item.quantity_4 != null) {
				// X軸に日付情報を代入
				this.x_value = item.date;
				// Y軸に「SPAD値」情報を代入
				this.y_value = item.quantity_4;

				// console.log("SPAD値のグラフを生成します");
			}
			// 2. 「茎長(length_1)」の情報が返ってきている場合(仮、クエリは必要な情報以外取ってこない想定)
			else if (item.length_1 != null) {
				// X軸に日付情報を代入
				this.x_value = item.date;
				// Y軸に「茎長」情報を代入
				this.y_value = item.length_1;

				// console.log("茎長のグラフを生成します");
			}
			// 3. 「葉長(length_2)」の情報が返ってきている場合(仮、クエリは必要な情報以外取ってこない想定)
			else if (item.length_2 != null) {
				// X軸に日付情報を代入
				this.x_value = item.date;
				// Y軸に「葉長」情報を代入
				this.y_value = item.length_2;

				// console.log("葉長のグラフを生成します");
			}
			// 4. 「葉幅(length_3)」の情報が返ってきている場合(仮、クエリは必要な情報以外取ってこない想定)
			else if (item.length_3 != null) {
				// X軸に日付情報を代入
				this.x_value = item.date;
				// Y軸に「葉幅」情報を代入
				this.y_value = item.length_3;

				// console.log("葉幅のグラフを生成します");
			}
			// 5. 「茎径(diameter)」の情報が返ってきている場合(仮、クエリは必要な情報以外取ってこない想定)
			else if (item.diameter != null) {
				// X軸に日付情報を代入
				this.x_value = item.date;
				// Y軸に「茎径」情報を代入
				this.y_value = item.diameter;

				// console.log("茎径のグラフを生成します");
			}
			// 6. 「開花段数(quantity_1)」の情報が返ってきている場合(仮、クエリは必要な情報以外取ってこない想定)
			else if (item.quantity_1 != null) {
				// X軸に日付情報を代入
				this.x_value = item.date;
				// Y軸に「開花段数」情報を代入
				this.y_value = item.quantity_1;

				// console.log("開花段数のグラフを生成します");
			}
			// 7. 「全葉数(quantity_2)」の情報が返ってきている場合(仮、クエリは必要な情報以外取ってこない想定)
			else if (item.quantity_2 != null) {
				// X軸に日付情報を代入
				this.x_value = item.date;
				// Y軸に「全葉数」情報を代入
				this.y_value = item.quantity_2;

				// console.log("全葉数のグラフを生成します");
			}
			// 8. 「収穫段数(quantity_3)」の情報が返ってきている場合(仮、クエリは必要な情報以外取ってこない想定)
			else if (item.quantity_3 != null) {
				// X軸に日付情報を代入
				this.x_value = item.date;
				// Y軸に「収穫段数」情報を代入
				this.y_value = item.quantity_3;

				// console.log("収穫段数のグラフを生成します");
			}
			// 養液情報(nutrient_solution)が返ってきている場合は、返ってきたパラメーターの情報を代入
			// 1. 「カルシウム(ca)」の情報が返ってきている場合(仮、クエリは必要な情報以外取ってこない想定)
			// データの中で、数値ではなく、文字列が格納されている場合は、そのデータはグラフにプロットしないようにする
			// caの場合、「Ur」と「None」の文字列が含まれていることがある
			else if (item.ca != null) {
				// 返ってきたデータが数値の場合には、Y軸に数値をセット
				if (item.ca != "Ur" && item.ca != "None") {
					// X軸に日付情報を代入
					this.x_value = item.date;
					// Y軸に「カルシウム」情報を代入
					this.y_value = item.ca;
				}
				// そうでなく、文字列の場合には、Y軸に空の情報をセット
				else {
					// X軸に日付情報を代入
					this.x_value = item.date;
					// Y軸に空の情報を代入
					this.y_value = undefined;
				}
				// console.log("カルシウムのグラフを生成します");
			}
			// 2. 「カリウム(k)」の情報が返ってきている場合(仮、クエリは必要な情報以外取ってこない想定)
			else if (item.k != null) {
				// 返ってきたデータが数値の場合には、Y軸に数値をセット
				if (item.k != "None" && item.k != "Ur" && item.k != "＊") {
					// X軸に日付情報を代入
					this.x_value = item.date;
					// Y軸に「カリウム」情報を代入
					this.y_value = item.k;
				}
				// そうでなく、文字列の場合には、Y軸に空の情報をセット
				else {
					// X軸に日付情報を代入
					this.x_value = item.date;
					// Y軸に空の情報を代入
					this.y_value = undefined;
				}
				// console.log("カリウムのグラフを生成します");
			}
			// 3. 「窒素(no3)」の情報が返ってきている場合(仮、クエリは必要な情報以外取ってこない想定)
			else if (item.no3 != null) {
				// 返ってきたデータが数値の場合には、Y軸に数値をセット
				if (item.no3 != "None" && item.no3 != "14r0") {
					// X軸に日付情報を代入
					this.x_value = item.date;
					// Y軸に「窒素」情報を代入
					this.y_value = item.no3;
				}
				// そうでなく、文字列の場合には、Y軸に空の情報をセット
				else {
					// X軸に日付情報を代入
					this.x_value = item.date;
					// Y軸に空の情報を代入
					this.y_value = undefined;
				}
				// console.log("窒素のグラフを生成します");
			}
			// 4. 「ph(pH)」の情報が返ってきている場合(仮、クエリは必要な情報以外取ってこない想定)
			// データの中で、数値ではなく、文字列が格納されている場合は、そのデータはグラフにプロットしないようにする
			// pHの場合、「NA」と「None」の文字列が含まれていることがある
			else if (item.ph != null) {
				// 返ってきたデータが数値の場合には、Y軸に数値をセット
				if (item.ph != "NA" && item.ph != "None") {
					// X軸に日付情報を代入
					this.x_value = item.date;
					// Y軸に「pH」情報を代入
					this.y_value = item.ph;
				}
				// そうでなく、文字列の場合には、Y軸に空の情報をセット
				else {
					// X軸に日付情報を代入
					this.x_value = item.date;
					// Y軸に空の情報を代入
					this.y_value = undefined;
				}
				// console.log("pHのグラフを生成します");
			}
			// 5. 「ec(EC値)」の情報が返ってきている場合(仮、クエリは必要な情報以外取ってこない想定)
			else if (item.ec != null) {
				// 返ってきたデータが数値の場合には、Y軸に数値をセット
				if (item.ec != "None") {
					// X軸に日付情報を代入
					this.x_value = item.date;
					// Y軸に「EC値」情報を代入
					this.y_value = item.ec;
				}
				// そうでなく、文字列の場合には、Y軸に空の情報をセット
				else {
					// X軸に日付情報を代入
					this.x_value = item.date;
					// Y軸に空の情報を代入
					this.y_value = undefined;
				}
				// console.log("EC値のグラフを生成します");
			}
			// 灌水量情報(liquid_supply_management)が返ってきている場合は、返ってきたパラメーターの情報を代入
			// 灌水量の変化量に対する問について、beforeとafterの両方が返ってきている場合
			// ただし、Y軸に描画させるデータは、「after」から「before」をひいたものを描画することとする
			else if (item.before != null && item.after != null) {
				// X軸に日付情報を代入
				this.x_value = item.date;

				// Y軸に灌水量の変更量(after - before)を代入

				// mlを削除後、Int型に変換
				const beforeValue = parseInt(item.before.replace("ml", ""));
				// console.log("beforeValue", beforeValue);

				const afterValue = parseInt(item.after.replace("ml", ""));
				// console.log("afterValue", afterValue);

				// どのくらい灌水量を変更したのかを「after - before」で計算
				const change = afterValue - beforeValue;
				// console.log("計算後の灌水量の変化量", change);

				// Y軸に灌水量の変化量を代入
				this.y_value = change;

				// console.log("灌水量データの水位の変化量のグラフ座標情報を設定");
			}
			// 灌水量データのみの問い合わせがあった場合(変更前のデータではなく、変更後のデータが返ってている場合)
			else if (item.before == undefined && item.after != undefined) {
				// X軸に日付情報を代入
				this.x_value = item.date;
				// Y軸に灌水量データ(変更後)を代入
				const afterValue = item.after.replace("ml", "");
				// console.log("afterValue", afterValue);

				this.y_value = afterValue;

				// console.log("灌水量データ(変更後)のグラフ座標情報を設定");
			}
		},
		// ApexChartsで描画させるグラフのオブジェクトを用意
		setGraph(graphType) {
			// 折れ線グラフ / 棒グラフ / pietobar（棒に変換）パターン
			if (graphType == "line" || graphType == "bar" || graphType == "pietobar") {
				const graphArray = {
					options: {
						chart: { toolbar: { show: false } },
						xaxis: {
							categories: [],
							labels: {
								// 文字列カテゴリの場合：yyyy-mm-dd → yyyy/mm/dd に統一
								formatter: (value) => {
									// value が数値（numeric 軸）で渡る場合はそのまま返す
									if (typeof value !== "string") return value;
									return value.replace(/-/g, "/");
								},
							},
						},
						stroke: { curve: "straight", width: 3 },
						markers: { size: 1 },
						tooltip: { enabled: true, theme: "dark" },
						dataLabels: { enabled: false },
						plotOptions: {
							bar: {
								distributed: true, // ← 棒ごとに色を配布
							},
						},
					},
					// 折れ線/棒は { name, data: [] } 形が正
					series: [{ name: "", data: [] }],
				};
				this.chart.graphArrayData.push(graphArray);
				this.graphIndex += 1;
			}

			// 円グラフ（pie / pietwospan 等）
			else {
				// 円グラフは labels を options に、数値を series（一次元配列）へ
				const graphArray = {
					options: {
						chart: { toolbar: { show: false } },
						tooltip: { enabled: true, theme: "dark" },
						dataLabels: {
							enabled: true,
							formatter: (val) => Math.round(val) + "%",
						},
						labels: [], // ← ラベルはここへ
					},
					series: [], // ← 数値の一次元配列
				};

				// 円グラフ(1つパターン)の場合
				if (graphType == "pie") {
					// 新しいグラフ生成用のグラフオブジェクトを配列に追加
					// 1つのグラフとして描画可能
					this.chart.graphArrayData.push(graphArray);
					// console.log("円グラフ設定をセット");

					// グラフのインデックスを1増やす
					this.graphIndex += 1;
					// console.log("graphIndex", this.graphIndex);
				}
			}
			// console.log("setGraph処理完了、現時点でのgraphIndex", this.graphIndex);
		},
		// グラフデータが格納されている配列をリセット
		resetGraphArray() {
			// リストの中身をリセット
			this.chart.graphArrayData = [];
			this.chart.graphArrayData.length = 0;

			// リストのインデックスをリセット
			this.graphIndex = -1;
			// console.log("グラフのリストの中身をリセットしました");
			// console.log("リセット後のgraphArrayDataの中身", this.chart.graphArrayData);
		},
	},
};
</script>

<style>
.chat-container {
	display: flex;
	flex-direction: column;
	height: 100vh;
	background-color: rgb(136, 174, 82);
	overflow: hidden;
}

/* デフォルトの margin（余白）をリセット */
* {
	margin: 0;
	padding: 0;
}

/*ChatBotのタイトル*/
.title {
	color: white;
	text-align: center;
	padding: 10px;
	flex: 0 0 auto;
}

/*サインアウトボタン*/
.signoutbtn {
	/*絶対位置指定*/
	position: absolute;
	/*右端に配置*/
	right: 10px;
	/*上端に配置*/
	top: 20px;
	background-color: transparent;
	border: none;
	cursor: pointer;
}

/*三本線のアイコンボタン*/
.threebaricon {
	position: absolute;
	left: 10px;
	top: 10px;
	background-color: transparent;
	border: none;
	cursor: pointer;
}

/*三本線アイコン*/
.threebar-icon {
	height: 20px;
	width: 20px;
}

/*メッセージ入力フォーム全体設定*/
.generalformposition {
	overflow-x: hidden;
	display: flex;
	width: 100%;
	font-size: 17.5px; /*フォントサイズを指定*/
	padding-left: 28%; /* 左端からの余白部分を設定 */
	padding-top: 20px;
	padding-bottom: 20px;
	background-color: rgb(136, 174, 82);
}

.selectVoice {
	position: absolute;
	bottom: 1%;
	padding-left: 28%; /*左端からの余白部分を設定*/
	padding-top: 20px;
}
/*メッセージ入力用フィールド*/
.input-container {
	/*要素を横並びに設定*/
	display: flex;
	position: relative;
	border-radius: 10px;
	border: 1px solid;
	transition: all 0.3s; /* スムーズなアニメーション */
	/*最大幅を半角75文字分に設定(これを超えると、文字列が折り返される)*/
	max-width: 65ch;
}
.input-container.highlighted {
	border: 2px solid black; /* フォーカス時のボーダー色 */
}
/*メッセージ入力フォーム*/
textarea {
	width: 700px;
	font-size: 16px;
	/*入力フォームの枠線を設定*/
	border: none;
	border-radius: 10px 0 0 10px;
	outline: none;
	/*改行されたときの入力フォームの最大・最小値を指定*/
	min-height: 42px;
	max-height: 105px;
	/*ユーザーによるリサイズを制限*/
	resize: none;
	overflow-y: auto;
	padding-left: 15px;
}

/*入力文字列の位置を設定*/
textarea {
	/*placeholderと入力開始位置を設定*/
	padding-left: 15px;
	padding-bottom: 0;
	/*改行した時の文字列の間隔を設定*/
	line-height: 1.3;
}

/*メッセージ送信ボタン(飛行機アイコン仕様)*/
.sendbtn {
	background-color: white;
	cursor: pointer;
	border: none;
	border-radius: 0 10px 10px 0; /* 右側の角を丸める */
}

/*紙飛行機アイコン*/
.paperfly-icon {
	height: 30px;
	width: 30px;
	padding: 0 10px 0 5px;
}

/*音声入力切替ボタン(マイクアイコン仕様)*/
.micbtn {
	background-color: white;
	border: none;
	cursor: pointer; /* カーソルをポインタに設定 */
}

/*音声入力アイコン*/
.mic-icon {
	height: 30px;
	width: 30px;
	padding: 0 5px 0 10px;
}

/* ボタン間の隙間を調整 */
.input-container > button {
	margin-left: -1px; /* ボタンが隣接している場合、1pxのマイナスマージンを設定 */
}
/* トグルスイッチのスタイル設定 */
.toggle-container {
	display: flex;
	align-items: center;
	margin-left: 20px; /* 左のマージンを調整 */
}

.toggle-switch {
	position: relative;
	display: inline-block;
	width: 65px; /* トグルの幅 */
	height: 30px; /* トグルの高さ */
}

.toggle-switch input {
	opacity: 0; /* チェックボックスは隠す */
	width: 0;
	height: 0;
}

.switch-slider {
	position: absolute;
	cursor: pointer;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: #ccc; /* オフの背景色 */
	border-radius: 34px;
	transition: 0.4s;
	margin-left: 10px;
}

.switch-slider:before {
	position: absolute;
	content: "";
	height: 20px; /* スライドボタンの高さ */
	width: 20px; /* スライドボタンの幅 */
	left: 5px; /* 左の余白 */
	bottom: 5px; /* 下の余白 */
	background-color: white; /* スライドボタンの色 */
	border-radius: 50%; /* 丸くする */
	transition: 0.4s;
}

/* チェック時のスタイル */
input:checked + .switch-slider {
	background-color: #2196f3; /* オンの背景色 */
}

input:checked + .switch-slider:before {
	transform: translateX(26px); /* スライドボタンを右に移動 */
}

/*メッセージ表示部分(可変)全体*/
main.message-container {
	/* 縦方向のスクロールを許可 */
	flex: 1;
	overflow-y: auto;
	overflow-x: hidden;
	width: 100%;
	box-sizing: border-box;
	margin-bottom: 0 !important;
}

/*メッセージ繰り返し出力部分*/
.message {
	/* メッセージをブロックレベルに */
	display: block;
	width: 100%;
	margin-bottom: 10px;
	/*左揃えに設定*/
	text-align: left;
}

/*アイコン表示設定(親要素)*/
.messageicon-container {
	/*相対位置を指定*/
	position: relative;
}

/*アイコン表示設定*/
.message-icon {
	/*縦横の幅を指定*/
	height: 30px;
	width: 30px;
	/* 絶対位置を指定 */
	position: absolute;
	/* 23px下に移動 */
	padding-top: 23px;
	/*左端からの幅を指定*/
	padding-left: 26%;
}

/*ゴミ箱ボタン表示設定(ユーザー側のみ)*/
.trashicon {
	/* 絶対位置を指定 */
	position: absolute;
	/* 23px下に移動 */
	padding-top: 30px;
	/*右端からの幅を指定*/
	right: 3%;
	/*ボタンを透明に設定*/
	background-color: transparent;
	border: none;
	cursor: pointer;
}

/*ゴミ箱アイコン表示設定(ユーザー側のみ)*/
.trash-icon {
	/*縦横の幅を指定*/
	height: 20px;
	width: 20px;
}

/*メッセージ出力部分*/
.message-text {
	/* display: block; */
	width: 100%;
	/*ブロック内における上下左右の余白を設定*/
	padding: 30px;
	/*文字の折り返しを設定*/
	overflow-wrap: break-word;
	word-wrap: break-word;
	word-break: break-word;
	/*フォント色を指定*/
	color: white;
	/*フォントサイズを指定*/
	font-size: 17.5px;
	/*左端からの余白部分を設定*/
	padding-left: 30%;
	/*右端からの余白部分を設定*/
	padding-right: 69%;
	/*最大幅を半角75文字分に設定(これを超えると、文字列が折り返される)*/
	max-width: 75ch;
	/* 改行を保持 */
	white-space: pre-wrap;
}

/*ユーザメッセージ表示部分(botの表示部分のみ、背景色を変更)*/
.user .message-text {
	/* ユーザー側メッセージの背景色 */
	background-color: rgb(136, 174, 82);
}

/*botメッセージ表示部分(botの表示部分のみ、背景色を変更)*/
.bot .message-text {
	/* bot側メッセージの背景色 */
	background-color: rgb(160, 185, 126);
}

/*botモードかつ、ぐるぐる表示部分(botの表示部分のみ、背景色を変更、かつぐるぐるも表示)*/
.bot .loader {
	/* bot側メッセージの背景色 */
	background-color: rgb(160, 185, 126);
}

/*ぐるぐる表示部分*/
.loader {
	/*色付け部分を画面全体に伸ばす*/
	width: 100%;
	/*ブロック内における上下左右の余白を設定*/
	padding: 30px;
	/*左端からの余白部分を設定*/
	padding-left: 30%;
	/*右端からの余白部分を設定*/
	padding-right: 69%;
}

/*AI Searchから取得した画像の大きさ設定*/
.image-size {
	/*縦を50%に縮小*/
	height: 50%;
	/*横を50%に縮小*/
	width: 50%;
}

/*デザインA(スマートフォン)*/
@media screen and (max-width: 480px) {
	.generalformposition {
		display: block;
	}
	/*メッセージ入力フォーム(子要素(送信ボタン含める))*/
	.input-container {
		position: relative;
		/*最大幅を半角40文字分に設定(これを超えると、文字列が折り返される)*/
		max-width: 40ch;
	}
	.toggle-container {
		margin-left: 10px;
		margin-top: 10px;
	}
}
/*スマートフォンサイズ、599px以下の時に適用するCSSを設定*/
/*変化させたいclassに変更を加えており、その他定義していないclassについてはデフォルトのCSSを適用している*/
@media screen and (max-width: 599px) {
	.chatbot-container {
		/* 1カラムに変更 */
		grid-template-columns: 1fr;
		/* 行を自動調整 */
		grid-template-rows: auto auto auto;
	}

	/*スマホサイズの場合には、アイコン、テキストのフォントを左側に寄せてサイズを小さくする*/
	/*サイドバーボタンのアイコン*/
	.threebar-icon {
		width: 15px;
		height: 15px;
	}

	/*チャット画面中のタイトル*/
	.title {
		font-size: 16px;
		text-align: center;
	}

	/*サインアウトボタン*/
	.signoutbtn {
		position: absolute;
		top: 10px;
		right: 5px;
		font-size: 10px;
	}

	/*メッセージアイコン*/
	.message-icon {
		/*縦横の幅を指定*/
		height: 25px;
		width: 25px;
		/* 絶対位置を指定 */
		position: absolute;
		/* 23px下に移動 */
		padding-top: 23px;
		/*左端からの幅を指定*/
		padding-left: 3%;
	}

	/*メッセージ表示領域*/
	.message-text {
		width: 100%;
		/*ブロック内における上下左右の余白を設定*/
		padding: 30px;
		/*文字の折り返しを設定*/
		overflow-wrap: break-word;
		word-wrap: break-word;
		word-break: break-word;
		/*フォント色を指定*/
		color: white;
		/*フォントサイズを指定*/
		font-size: 14.5px;
		/*左端からの余白部分を設定*/
		padding-left: 15%;
		/*右端からの余白部分を設定*/
		padding-right: 69%;
		/*最大幅を半角35文字分に設定(これを超えると、文字列が折り返される)*/
		max-width: 40ch;
		/* 改行を保持 */
		white-space: pre-wrap;
	}

	/*メッセージ入力フォーム(全体)*/
	.generalformposition {
		/*フォントサイズを指定*/
		font-size: 14.5px;
		/*左端からの余白部分を設定*/
		padding-left: 5%;
	}

	/*メッセージ入力フォーム(子要素(送信ボタン含める))*/
	.input-container {
		position: relative;
		/*最大幅を半角40文字分に設定(これを超えると、文字列が折り返される)*/
		max-width: 40ch;
	}
	textarea {
		font-size: 14px;
	}

	/*LLMからの回答待ち、ぐるぐる表示*/
	.loader {
		/*左端からの余白部分を設定*/
		padding-left: 15%;
		/*右端からの余白部分を設定*/
		padding-right: 69%;
	}

	/*AI Searchから取得した画像の大きさ設定*/
	.image-size {
		/*縦を100%に拡大*/
		height: 100%;
		/*横を100%に拡大*/
		width: 100%;
	}
}

/*デザインB(タブレット縦)*/
@media screen and (min-width: 600px) and (max-width: 799px) {
	/*メッセージ入力フォーム(子要素(送信ボタン含める))*/
	.input-container {
		position: relative;
		/*最大幅を半角50文字分に設定(これを超えると、文字列が折り返される)*/
		max-width: 50ch;
	}
	/*メッセージアイコン*/
	.message-icon {
		/* 絶対位置を指定 */
		position: absolute;
		/* 23px下に移動 */
		padding-top: 23px;
		/*左端からの幅を指定*/
		padding-left: 2%;
	}

	/*メッセージ表示領域*/
	.message-text {
		/*左端からの余白部分を設定*/
		padding-left: 7%;
		/*右端からの余白部分を設定*/
		padding-right: 69%;
		/*最大幅を半角73文字分に設定(これを超えると、文字列が折り返される)*/
		max-width: 73ch;
		/* フォントサイズを調整 */
		font-size: 16px;
	}

	/*メッセージ入力フォーム(全体)*/
	.generalformposition {
		padding-left: 3%; /*左端からの余白部分を設定*/
		font-size: 16px; /* フォントサイズを調整 */
	}
	/*LLMからの回答待ち、ぐるぐる表示*/
	.loader {
		/*左端からの余白部分を設定*/
		padding-left: 7%;
		/*右端からの余白部分を設定*/
		padding-right: 69%;
	}

	/*AI Searchから取得した画像の大きさ設定*/
	.image-size {
		/*縦を100%に拡大*/
		height: 100%;
		/*横を100%に拡大*/
		width: 100%;
	}
}
/*タブレット(縦)サイズ、600px以上、1079px以下の時に適用するCSSを設定*/
/*変化させたいclassに変更を加えており、その他定義していないclassについてはデフォルトのCSSを適用している*/
@media screen and (min-width: 800px) and (max-width: 1079px) {
	/*タブレット(縦)サイズの場合には、アイコン、テキストのフォントを左側に寄せるのみ*/

	/*メッセージアイコン*/
	.message-icon {
		/* 絶対位置を指定 */
		position: absolute;
		/* 23px下に移動 */
		padding-top: 23px;
		/*左端からの幅を指定*/
		padding-left: 2%;
	}

	/*メッセージ表示領域*/
	.message-text {
		/*左端からの余白部分を設定*/
		padding-left: 7%;
		/*右端からの余白部分を設定*/
		padding-right: 69%;
		/*最大幅を半角73文字分に設定(これを超えると、文字列が折り返される)*/
		max-width: 73ch;
		/* フォントサイズを調整 */
		font-size: 16px;
	}

	/*メッセージ入力フォーム(全体)*/
	.generalformposition {
		padding-left: 3%; /*左端からの余白部分を設定*/
		font-size: 16px; /* フォントサイズを調整 */
	}
	/*メッセージ入力用フィールド*/
	.input-container {
		/*最大幅を半角65文字分に設定(これを超えると、文字列が折り返される)*/
		max-width: 65ch;
	}
	/*LLMからの回答待ち、ぐるぐる表示*/
	.loader {
		/*左端からの余白部分を設定*/
		padding-left: 7%;
		/*右端からの余白部分を設定*/
		padding-right: 69%;
	}

	/*AI Searchから取得した画像の大きさ設定*/
	.image-size {
		/*縦を100%に拡大*/
		height: 100%;
		/*横を100%に拡大*/
		width: 100%;
	}
}

/*デザインC(PC/タブレット横)*/
/*1080px以上になった場合には、デフォルトで定義したCSS通りに描画*/

/* ドロップダウンメニューの全体設定 */
.dropdown {
	position: relative;
	display: inline-block;
}

.dropdown button {
	padding: 10px;
	background-color: #32a89d;
	color: white;
	border: none;
	cursor: pointer;
	/* ボタンの幅を指定 */
	width: 110px;
}

/* ドロップダウンメニュー */
.dropdown ul {
	position: absolute;
	background-color: white;
	border: 1px solid #ccc;
	list-style-type: none;
	padding: 5px 0;
	margin: 0;
	z-index: 1000;
	/* ボタンの幅を指定 */
	width: 110px;
}

/* リスト項目のスタイル */
.dropdown li {
	color: black;
	/* 上下のパディングを少し縮め */
	padding: 6px 16px;
	/* フォントサイズを12pxに設定 */
	font-size: 13px;
	cursor: pointer;
}

/* ホバー時のスタイル */
.dropdown li:hover {
	background-color: #f1f1f1;
}

.chart-card {
	background: rgb(160, 185, 126); /* カード背景 */
	border-radius: 8px; /* 角丸 */
	box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1); /* 軽い影 */
	padding: 8px; /* 内側余白 */
	margin-top: 8px; /* 外側余白 */
	display: flex;
	flex-direction: column; /* 縦並び */
	/* align-items: center; 中央寄せ */
	justify-content: center;
	transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.chart-card h5.day-label {
	margin-top: 12px;
	font-size: 14px;
	font-weight: bold;
	color: #333;
	text-align: center;
}

.charts-grid {
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
	gap: 8px;
	/* padding: 8px; */
}
</style>
